export default {
  ' = Equal to': ' = 等于',
  '# of Articles': '文章数',
  '# of Followers': '粉丝数',
  '# of Hours Watched': '观看时长',
  '# of Influencers': '网红数',
  '# of Mentions': '声量',
  '# of Selected Positive Reviews': '筛选好评数量',
  '# of Video Engagement': '视频互动量',
  '#PUBGMID2025Creator': '#PUBGMID2025Creator',
  '#PUBGMIDJadiCreator2025': '#PUBGMIDJadiCreator2025',
  '#PUBGMOBILEMMM2025Creator': '#PUBGMOBILEMMM2025Creator',
  '#PUBGMTH2025Creator': '#PUBGMTH2025Creator',
  '% of Official Content': '官方内容量占比',
  '% of UGC Content': 'UGC内容量占比',
  '(Available for YouTube videos with subtitles only.)': '(仅支持带字幕的YouTube视频)',
  '(Chart Interaction: Report Type → Subtopic → Keyword) Click a line to filter linked subtopics and keywords':
    '(图表联动：举报类型 → 子话题 → 关键词） 点击对应折线筛选联动子话题',
  '(Expected to wait for 0.5h ~ 4h)': '（预计等待0.5h~4h）',
  '(Only supports videos from certain channels)': '(仅支持部分渠道的视频)',
  '(Refreshed Every 30 Mins)': '(每30分钟刷新一次)',
  '(Remaining system uses today: {remainder}/{total})': '(系统剩余使用次数{remainder}/{total})',
  '(Top 100)': '(前100)',
  '(case-insensitive)': '（不区分大小写）',
  '(hours)': '(小时)',
  '({start_time} to {end_time})': ' ({start_time} 至 {end_time})',
  '-': '-',
  '/': '/',
  '0 ~ 5 people': '0 ~ 5 人',
  '1 Star Reviews': '5星评论量',
  '1. The crawler is unable to retrieve the necessary content for a summary from this link':
    '1. 该链接爬虫无法获取总结所需内容',
  '1.5 Years Summary': '1.5年舆情总结',
  '10 ~ 20 people': '10 ~ 20 人',
  '1K+': '1K+',
  '2 Star Reviews': '4星评论量',
  '2. Gemini API is unstable': '2. Gemini API不稳定',
  '3 Star Reviews': '3星评论量',
  '30-Day Positive %': '30天正面占比',
  '4 Star Reviews': '2星评论量',
  '5 Star Reviews': '1星评论量',
  '5 ~ 10 people': '5 ~ 10 人',
  '< Less than': '< 小于',
  '> 20 people': '> 20 人',
  '> Greater than': '> 大于',
  'A page with the same name already exists.': '已存在相同名称的报表',
  'A setting with the same name already exists, click Save to replace this setting.':
    '已有相同名称配置，请点击“保存”进行覆盖更新',
  ACV: '直播观众平均值（ACV）',
  'AI Analysis Hub': 'AI分析中心',
  'AI Analysis of Hot UGC Content': 'UGC热门内容AI分析',
  'AI Chat': 'AI对话',
  'AI Chat History': 'AI对话历史',
  'AI Content Summary': 'AI内容总结',
  'AI Core Content': 'AI 核心内容',
  'AI Hook Analysis': 'AI钩子解读',
  'AI Insight Report': 'AI洞察报告',
  'AI Live Stream Comments Summary': 'AI弹幕总结',
  'AI Meme Interpretation': 'AI热梗解读',
  'AI Opinions Summary': 'AI 舆情总结',
  'AI Options': 'AI 模型',
  'AI Quantitative Summary': '分渠道AI总结',
  'AI Settings': 'AI 设置',
  'AI Summary': 'AI 总结',
  'AI Summary Demo': 'AI总结案例',
  'AI Summary Events': 'AI总结事件',
  'AI Summary Setting': 'AI总结设置',
  'AI Tagging': 'AI标注中',
  'AI Tags': 'AI标签',
  'AI Task Center': 'AI任务中心',
  'AI Topic': 'AI 话题',
  'AI Topic Analysis': 'AI话题分析',
  'AI summary is not currently supported for this content type.': '当前类型暂不支持 AI 总结',
  'AI-generated': 'AI生成',
  'AI Topic Subscriptions': 'AI 话题例行',
  'ALL Reviews Positive%': '历史累积正面评论占比',
  'AVG DAU': '平均日活',
  'AVG Negative': '负面话题',
  'AVG Positive': '正面话题',
  Access: '权限',
  Account: '官号',
  'Account Monitor': '监控官号',
  'Account Post': '官号主贴量',
  'Account Posts': '官号主贴量',
  'Account Posts & Engagement': '官号发帖及互动量',
  'Account Posts: Summary of the number of Account posts on social media.':
    '官号主贴量：在社交媒体获取该游戏官号下的所有主贴内容。',
  'Account Trends': '趋势分析',
  Accumulated: '全网汇总统计',
  'Accumulated Daily New Ads': '累计新增广告数',
  'Accumulated Monthly Cumulative Impressions': '月日均累计曝光量',
  'Accumulated Monthly New Ads': '月累计新增广告数',
  'Accumulated Monthly New Creatives': '月累计新增素材数',
  'Accumulated New Ads': '累计新增广告数',
  'Accumulated New Creatives': '累计新增素材数',
  'Accumulated Weekly Cumulative Impressions': '周日均累计曝光量',
  'Accumulated Weekly New Ads': '周累计新增广告数',
  'Accumulated Weekly New Creatives': '周累计新增素材数',
  Action: '操作',
  Actions: '操作',
  Active: '活跃网红',
  'Active Ad Channel Analysis': '在投广告渠道分析',
  'Active Ads': '在投广告数',
  'Active Ads Channel Share': '在投广告数渠道占比',
  'Active Ads Competitor Share': '在投广告数竞品间份额',
  'Active Ads Country & Type Analysis': '在投广告国家&类型分析',
  'Active Ads Engagements': '在投广告累计互动量',
  'Active Ads Estimated Heat': '在投广告热度估值',
  'Active Ads Impressions': '在投广告曝光量',
  'Active Ads by Country': '在投广告数分国家',
  'Active Ads by Creative Type': '在投广告数分素材类型',
  'Active Ads% by Channel': '在投广告数渠道占比',
  'Active Creatives': '在投素材数',
  'Active Date': '在投日期',
  'Active Days': '活跃天数',
  'Active Image Ads': '在投图片广告数',
  'Active Playable Ads': '在投可玩广告数',
  'Active Video Ads': '在投视频广告数',
  'Ad Count': '投放数',
  'Ad Creatives': '广告创意',
  'Ad Cumulative Heat': '投放累计热度',
  'Ad Delivery Overview': '广告投放概览',
  'Ad Duration': '广告时长',
  Add: '勾选游戏',
  'Add & Sort Games': '添加游戏 & 排序',
  'Add Filter': '添加筛选器',
  'Add Filters': '增加筛选器',
  'Add Games to Compare': '添加竞品游戏',
  'Add Schedule': '新增日程',
  'Add Security-Related Crawling Keywords': '新增安全相关爬虫关键词',
  'Add URL': '添加URL',
  'Add a new version': '新增版本',
  'Add modules': '新增模块',
  'Add publish schedule for {day}': '新增{day}发布日程',
  'Add through the directory': '通过目录添加',
  'Add to My Report': '添加到我的报表',
  'Add to My Reports': '添加到我的报表',
  'Added AI Tag, Click to View': '新增AI标签，点击查看',
  'Added AI Video Content Summary, Click to View': '新增 AI 视频内容总结，点击查看',
  'Added Comment Count': '新增评论量',
  'Added Negative%': '新增评论负面评论占比',
  'Added Rating': '新增评论平均评分',
  'Added Reviews': '新增评论',
  'Added Reviews Positive%': '新增评论正面%',
  'Adding all relevant words': '覆盖所有合成词后',
  'Addition failed.': '添加失败',
  Adj: '形容词',
  Ads: '广告',
  'Ads-1': '广告数',
  Advanced: '高级版',
  'Advanced Quantitative Summary': '高级量化总结',
  'Advanced Summary': '高级总结',
  'Advanced quantitative — AI captures more opinions and quantifies each precisely.':
    '高级量化—AI 捕捉更多观点，并对每一项进行精确量化。',
  'After changing the filter criteria, you need to click confirm to refresh the page.':
    '更改筛选条件后，需要点击Confirm刷新页面',
  'After searching the name of the competitor, click the button of the Opinions system to enter the Opinions homepage of the competitor.':
    '通过搜索竞品名称，点击舆情系统来到竞品舆情主页。',
  'After selecting keywords or topics, filtering for posts is currently not supported.':
    '选中关键字或话题后，暂不支持筛选主贴',
  'After selecting the First Correlation Words on the left, the corresponding Second Correlation Words will be displayed here.':
    '选中左侧栏目的一级相关词后，此处将展示对应的二级相关词。',
  'After selecting the hour filter, the newly added hour section is set to move up by default.':
    '选择小时筛选后，小时新增板块默认上调。',
  'After the AI summary is complete, it will be displayed automatically. No need to wait on this page.':
    'AI总结完成后自动显示。无需在此等待。',
  'After the data is loaded, the report image can be downloaded.': '数据加载完成后，可下载报告图片',
  'After unsubscribing, you will no longer receive AI Summary WeCom notifications.':
    '取消订阅后，您将不会收到AI总结的企业微信推送。',
  'After unsubscribing, you will no longer receive AI Summary email notifications.':
    '取消订阅后，您将不再接收AI总结的邮件通知。',
  Agent: '模型',
  Aggregated: '汇总',
  Airtime: '直播时长',
  'Airtime (hours)': '直播时长(小时)',
  'Airtime(hours)': '直播时长(小时)',
  'Airtime: take the sum value of the hours broadcast by all streamers.': '直播时长：该时段所有直播间的在线时长总和。',
  'Alert Countries': '筛选告警国家',
  'Align to Release': '对齐上线时间',
  'Aligned by Launch time': '对照相同上线天数',
  All: '全部',
  'All AI summary tasks generated on individual game pages will be displayed here':
    '各游戏下生成的AI总结任务都将显示在本页',
  'All Articles': '新闻总数',
  'All Comments': '总评论量',
  'All Editions': '所有版本',
  'All Engagement': '总互动量',
  'All Engagements: the number of Engagements of videos and posts, including likes, comments, and shares.':
    '互动量：所有视频和文字贴的互动量，包括点赞、评论、转发。',
  'All Followers': '全平台粉丝量',
  'All Games': '全部游戏',
  'All Likes': '总点赞量',
  'All Publications': '总发帖量',
  'All Reports': '所有报告',
  'All Reviews': '全部评论',
  'All Reviews Negative%': '全部评论负面占比',
  'All Reviews Positive%': '全部评论正面占比',
  'All Reviews Positive%-1': '全部评论正面%',
  'All Reviews of All Language': '全部评论(所有语种)',
  'All Reviews of Language': '当前语种全部评论',
  'All Reviews of Supported Language': '已支持语种的全部评论',
  'All Reviews%': '全部评论占比',
  'All Time': '所有时段',
  'All Topic': '所有话题',
  'All Views': '全平台观看量',
  'All data below sourced from {Levelup} with 1 day delay (T-1)': '以下所有数据来源于{Levelup}，有1天延迟',
  'All of Time': '全部时间',
  'All reviews are displayed in their original text and can be translated into either Chinese or English.':
    '所有评论优先展示原文，支持翻译为中文或英文。',
  'All-1': '全员',
  'An English GPT report will be generated for you from 时间 to 时间. Could you please confirm the email address to receive the report? You can click to view the preview format.':
    '我们将为您生成一份从 时间 到 时间 的英文 GPT 报告。请确认接收报告的电子邮件地址。您可以点击预览报告格式。',
  'Analysis Generate failed, please try again': '报告生成失败，请重试',
  'Analysis Name': '报告名称',
  'Analysis Target': '分析目标',
  'Analysis Task Progress': '分析任务进程',
  'Analysis Time Range': '时间范围',
  'Analysis generate failed, please try again': '报告创建失败，请重试',
  'Analysis save failed': '保存失败',
  'Analysis will cover comments from {date}. Please  verify whether this period includes the original post publication date.':
    '将分析 {date} 的评论内容，请确认是否覆盖帖子发布时间。',
  'Analyze latest the 5-min clip': '分析最新五分钟数据',
  'Analyzes Opinions data using multivariate analysis, including mentions, sentiment, topics, channels, location, and language':
    '获取舆情声量与情感总况、话题占比、热门渠道、地域和语言分布等多元分析',
  'Anchor Words': '锚定词',
  'Anomaly Overview': '异动概述',
  'App Annie DAU': 'App Annie 日活',
  'App Annie Download': 'App Annie 下载',
  'App Annie MAU': 'App Annie 月活',
  'App Annie Revenue': 'App Annie 收入',
  'App Annie WAU': 'App Annie 周活',
  'App Store': 'App Store',
  April: '四月',
  'Are you sure to remove from Favorites?': '是否从我的收藏中移除报告?',
  'Are you sure to unsubscribed ？': '是否确认取消报告订阅？',
  Article: '文章',
  Asc: '升序',
  'At Review Time': '评论时游玩时长',
  'Attribute by': '分组',
  'Attribution Breakdown': '因素拆解',
  'Audience Performance': '互动表现',
  'Audience Reviews': '观众评论',
  August: '八月',
  'Auto Generated Sentiment': '自动生成',
  'Auto-saves to Summary List': '自动保存到报告列表',
  'Automatically verify tagging accuracy': '自动验证标注结果准确性',
  Availability: '是否可用',
  Average: '平均值',
  'Average Engagement': '平均互动强度',
  'Average Rating': '平均评分',
  'Average the score values of all reviews for the selected filter (including Date, Region/Country, Sentiment, and other filters).':
    '所选筛选条件内（包括日期、国家、情感分等其他筛选器），所有评论评分值求平均。',
  'Avg Brand Affinity': '平均品牌亲密度',
  'Avg CCV': '直播观众平均值',
  'Avg CCV (Average concurrent viewers): Average number of viewers per platform. The calculation method is as follows: After obtaining the average value of viewers on each platform, the data is summarized, and then the average viewers value is calculated based on the summarized results.':
    '直播观众平均值：各平台平均拥有的观看用户数。计算方法如下：获得各平台的观看用户平均值后，进行数据汇总，再针对汇总结果求平均。',
  'Avg CCV (Average concurrent viewers): take the average value of viewers watching the stream live.':
    '直播观众平均值：观看直播的观众的平均值。',
  'Avg Engagement': '平均互动量',
  'Avg Engagement Rate': '平均互动率',
  'Avg Views': '平均观看量',
  'Avg. Active Ads': '平均在投广告数',
  'Avg. Active Ads Channel Share': '日均在投广告数渠道占比',
  'Avg. Active Ads Competitor Share': '日均在投广告数竞品间份额',
  'Avg. Active Ads Estimated Heat': '日均在投广告热度估值',
  'Avg. Active Creatives': '平均在投素材数',
  'Avg. CCV': '直播观众平均值',
  'Avg. DAU': '平均日活',
  'Avg. Daily Active Ads': '日均在投广告数',
  'Avg. Daily Active Creatives': '日均在投素材数',
  'Avg. Daily Active Image Ads': '日均在投图片广告数',
  'Avg. Daily Active Playable Ads': '日均在投试玩广告数',
  'Avg. Daily Active Video Ads': '日均在投视频广告数',
  'Avg. Days Active': '平均在投天数',
  'Avg. Downloads': '日均下载',
  'Avg. MAU': '平均月活',
  'Avg. Monthly Active Ads': '月日均在投广告数',
  'Avg. Monthly Active Ads Channel Share': '月日均在投广告数渠道占比',
  'Avg. Monthly Active Ads Competitor Share': '月日均在投广告数竞品间份额',
  'Avg. Monthly Active Ads Engagements': '月日均在投广告累计互动量',
  'Avg. Monthly Active Ads Estimated Heat': '月日均在投广告热度估值',
  'Avg. Monthly Active Ads by Country': '月日在投广告数分国家',
  'Avg. Monthly Active Ads by Creative Type': '月日在投广告数分素材类型',
  'Avg. Monthly Active Ads% by Channel': '月日均在投广告数渠道占比',
  'Avg. Monthly Active Creatives': '月日均在投素材数',
  'Avg. Monthly Active Image Ads': '月日均在投图片广告数',
  'Avg. Monthly Active Playable Ads': '月日均在投试玩广告数',
  'Avg. Monthly Active Video Ads': '月日均在投视频广告数',
  'Avg. Monthly Cumulative Impressions by Type': '月日在投广告累计互动量分互动类型',
  'Avg. Monthly Estimated Cumulative Heat': '月日均累计热度估值',
  'Avg. Monthly Total Impressions on Active Ads': '月日均在投广告累计曝光量',
  'Avg. Rating of Game Store Reviews': '游戏商店评论平均评分',
  'Avg. Sentiment': '平均情感分',
  'Avg. Total Impressions on Active Ads': '日均在投广告累计曝光量',
  'Avg. Views / Video': '视频平均观看量',
  'Avg. WAU': '平均周活',
  'Avg. Weekly Active Ads': '周日均在投广告数',
  'Avg. Weekly Active Ads Channel Share': '周日均在投广告数渠道占比',
  'Avg. Weekly Active Ads Competitor Share': '周日均在投广告数竞品间份额',
  'Avg. Weekly Active Ads Engagements': '周日均在投广告累计互动量',
  'Avg. Weekly Active Ads Estimated Heat': '周日均在投广告热度估值',
  'Avg. Weekly Active Ads by Country': '周日在投广告数分国家',
  'Avg. Weekly Active Ads by Creative Type': '周日在投广告数分素材类型',
  'Avg. Weekly Active Ads% by Channel': '周日均在投广告数渠道占比',
  'Avg. Weekly Active Creatives': '周日均在投素材数',
  'Avg. Weekly Active Image Ads': '周日均在投图片广告数',
  'Avg. Weekly Active Playable Ads': '周日均在投试玩广告数',
  'Avg. Weekly Active Video Ads': '周日均在投视频广告数',
  'Avg. Weekly Cumulative Impressions by Type': '周日在投广告累计互动量分互动类型',
  'Avg. Weekly Estimated Cumulative Heat': '周日均累计热度估值',
  'Avg. Weekly Total Impressions on Active Ads': '周日均在投广告累计曝光量',
  BR: 'BR',
  Back: '返回',
  'Bar chart': '柱状图',
  Basic: '基础版',
  'Basic Summary': '基础总结',
  Basics: '基础内容',
  Battleid: '战斗ID',
  Beat: '新闻口',
  'Because the {titile} is not available for this video.': '因为该视频暂不支持获得{titile}内容',
  Before: '前向',
  'Before {time}': '早于{time}',
  Behind: '后向',
  Biweekly: '双周',
  'Block chart': '方块图',
  Body: '文案',
  'Brand Affinity': '品牌亲密度',
  'Brand Creator List': '品牌网红列表',
  'Brand Health': '品牌健康度',
  'Brand Overview': '品牌网红概览',
  'Brand Performance': '网红品牌表现',
  'Brand-Related Avg Views': '品牌游戏平均观看量',
  'Brand-Related Publications': '品牌游戏发帖量',
  'Brand-Related Views Loss Rate': '品牌观看量折损率',
  'Broad-match': '拓展匹配',
  'Broad-match with multiple languages': '多语言拓展匹配',
  'Bubble Size = |{id}|': '气泡大小 = |{id}|',
  'By Account': '分官号统计',
  'By Channel': '分渠道',
  'By Chapter': '分章节',
  'By Content': '内容匹配',
  'By Country': '分国家',
  'By Date': '分日期',
  'By Engagement': '分互动量统计',
  'By Engagement Type': '分互动类型统计',
  'By Follower Range': '分网红粉丝数统计',
  'By Followers': '分粉丝量统计',
  'By Language': '分语言',
  'By Media Type': '分媒体类型统计',
  'By Mentions Type': '分声量类型统计',
  'By Official Account': '分官号',
  'By Patch': '分热更/补丁',
  'By Rating': '分评分数统计',
  'By Rating%': '分评分%统计',
  'By Region/Country': '区域/国家评分列表',
  'By Release-1': '分正式版',
  'By Season': '分篇章',
  'By Sentiment': '分情感统计',
  'By Subtopic': '分子话题',
  'By Title': '标题匹配',
  'By Validation': '分有效性统计',
  'By Views': '分观看量统计',
  'By sorting, get information on the hottest and fastest growing internet influencers.':
    '通过排序，获得当前最火、涨粉最快的网红。',
  'CA7 Bug Report': 'CA7 Bug报告',
  'CA7 Feedback Report': 'CA7反馈报告',
  'CA7 Performance Report': 'CA7 性能报告',
  CCV: '直播观众量',
  'Calculated by Likes': '按点赞量统计',
  'Calculated by Views': '按观看量统计',
  'Calculated using TikTok data for new videos entering the all-time Top 500 by views.':
    '基于 TikTok 渠道数据，统计每日跻身历史播放量 Top 500 的新增视频',
  'Calculation Method': '计算方法',
  "Can't be empty": '不可为空，请输入内容',
  "Can't be null": '不能为空',
  "Can't generate AI summary: No live stream comment found": '无弹幕数据可生成AI总结报告',
  "Can't generate AI summary: No subtitle found": '无字幕数据可生成AI总结报告',
  Cancel: '取消',
  'Cannot be empty': '不能为空',
  Card: '卡片',
  Category: '分类',
  'Category-2': '品类',
  'Category-3': '类',
  Change: '环比',
  'Change Breakdown by Dimension': '分维度波动一览',
  'Change Rate': '环比',
  'Change%': '变化率',
  Channel: '渠道',
  'Channel / Region / Market / Language Distribution (Top 3)': '渠道/地区/市场/语言分布(前3)',
  'Channel Comparison': '分渠道游戏投放对比',
  'Channel Count': '直播间数量',
  'Channel Covered': '渠道包括',
  'Channel Distribution': '网红渠道分布',
  'Channel Performance': '分渠道表现',
  'Channel Settings': '渠道维度',
  'Channel Share Rankings': '渠道市场排行',
  'Channel Trends': '趋势分析',
  'Channel Type': '渠道类型',
  'Channel-1': '渠道',
  'Channel-2': '直播间',
  'Channels Share': '直播间分布',
  Chapter: '章节',
  'Character Length': '弹幕字数',
  Chatting: '聊天室',
  Chinese: '中文',
  'Chinese Translation': '中文翻译',
  'Chinese Translation Editing': '编辑中文翻译',
  'Chinese Translation': '中文翻译',
  'Chinese Translation Editing': '编辑中文翻译',
  'Chinese Translation Editing History': '中文翻译历史',
  'Choose Region/Country': '选择地区/国家',
  'Choose Time': '选择时段',
  Citation: '注解',
  'Clear All': '清空',
  'Clear game and date': '清空游戏及日期',
  'Click a keyword to view the relevant reviews.': '点击关键字下钻查看相关具体评论详情。',
  'Click hashtag to view more details': '点击Hashtag前往详情页',
  'Click on a keyword to access the details page for specific reviews.': '点击关键字，下钻查看具体详细评论。',
  'Click on a keyword to view the relevant reviews.': '点击关键字下钻查看相关具体评论详情。',
  'Click on any keyword to filter reviews.': '点击任意关键字筛选评论。',
  'Click the Setting button on the right to add competitors.': '点击右侧设置按钮，可添加竞品。',
  'Click the button below to create a new report, and it will automatically update based on your selected schedule.':
    '请点击下方按钮新建报告，设定周期后系统将自动更新内容。',
  'Click the chart to filter the feeds data below': '点击图表可筛选下方评论数据',
  'Click the chart to to view related keywords and reviews': '点击图表查看相关的关键字和评论',
  'Click the chart to view related reviews': '点击图表查看相关评论',
  'Click the chart to view related videos': '点击图表查看相关视频',
  'Click the chart to view reviews. Sorted by [{sortBy}] by default.': '点击图表查看评论，默认按[{sortBy}]排序',
  'Click the chart to view top 3 reviews': '点击图表查看前3评论',
  'Click the row or the meme title to view detail': '点击行或热梗标题查看详情',
  'Click the table to view the details of comments.': '点击表格查看评论详情',
  'Click these metrics to view multi-dimensional live streaming data.': '点击指标，查看多维度的直播数据。',
  'Click to apply': '点击应用',
  'Click to deselect negative reviews': '点击取消选择负面评论',
  'Click to deselect neutral reviews': '点击取消选择中性评论',
  'Click to deselect positive reviews': '点击取消选择正面评论',
  'Click to deselect {sentiment} content': '点击取消筛选{sentiment}内容',
  'Click to download all opinion metrics. You can check any metrics and split the metrics by the selected dimension.':
    '点击下载所有舆情指标，任意勾选，支持按所选维度拆分。',
  'Click to go to Feeds': '点击此处前往【评论/资讯详情页】',
  'Click to go to Key Opinions': '点击此处前往【核心舆情页】',
  'Click to go to [Feeds]': '点击此处前往【评论/资讯详情页】',
  'Click to go to [Key Opinions]': '点击此处前往【核心舆情页】',
  'Click to select negative reviews': '点击选择负面评论',
  'Click to select neutral reviews': '点击选择中性评论',
  'Click to select positive reviews': '点击选择正面评论',
  'Click to select {sentiment} content': '点击筛选{sentiment}内容',
  'Click to view channel & language distribution': '点击查看渠道&语种分布',
  'Click to view details': '查看帖子详情',
  'Click to view recent event.': '请先点击查看近期事件。',
  'Click to view recent report': '点击查看近期报告',
  'Click to view recent score.': '点击查看最近评分。',
  'Click to view related {series}': '点击查看相关{series}',
  'Click to view the anomaly analysis': '点击查看异动分析',
  "Click to {text} for the feedback's original data source": '点击{text}查看对应原始评论',
  Close: '关闭',
  'Close-1': '收起',
  Cloud: '词云',
  Coins: '投币数',
  Collapse: '收起',
  'Collapse All': '收起全部',
  'Collapse Filter': '折叠选项',
  'Collected Countries': '筛选关注国家',
  'Collected via DataBrain crawler': '评论来自DataBrain爬虫',
  'Collected via DataBrain crawler, with statistics generated based on filters':
    '评论来自DataBrain爬虫，并基于页面筛选条件自动生成统计结果',
  'Color = Report Type': '颜色 = 举报类型',
  Comment: '评论量',
  'Comment Area': '评论区域',
  'Comment Channel Type': '评论渠道类型',
  'Comment Details': '评论详情',
  'Comment End Date': '评论结束日期',
  'Comment Id': '评论ID',
  'Comment Sentiment': '评论情感分',
  'Comment Start Date': '评论起始日期',
  'Comment Summary': '评论总结',
  'Comment Type': '帖子类型',
  'Comment Uin': '帖子Uin',
  'Comment language': '评论语种',
  Comments: '评论量',
  'Comments (Exclude Discord)': '社媒评论(除Discord)',
  'Comments Change%': '评论量环比',
  'Comments Engagement': '评论互动量',
  'Comments On Posts': '帖文评论',
  'Comments On Videos': '视频评论',
  'Comments Prompt Modification': '修改评论提示词',
  'Comments Summary': '评论总结',
  'Comments on Posts': '图文帖评论',
  'Comments on Streams': '直播评论',
  'Comments on Text Posts': '文字主贴评论',
  'Comments on Videos': '视频评论',
  'Comments on Videos-1': '视频主贴评论',
  'Comments on this post have not yet been crawled.': '本贴评论暂未爬取',
  'Comments-1': '社媒评论(除Discord)',
  'Comments-2': '评论',
  Common: '通用',
  'Common Publisher (0-1K)': '普通发帖用户 (0-1K)',
  'Common(0K ~ 1K)': '普通发帖用户(0K ~ 1K)',
  Community: '社区',
  'Community Analysis': '社区分析',
  'Community Performance': '社区表现',
  'Community Performance Monitoring: Video, Streaming, and Influencers': '视频直播网红等社区表现监控',
  Compare: '对比',
  'Compare Competitors': '竞品对比',
  'Compare Key Metrics': '核心指标对比',
  'Compare by': '比较指标',
  'Compare-1': '竞品对比',
  'Compared with Average': '本周相比均值',
  'Compared with the following period, there is no topic of mentions growth.': '对比以下时段，暂无声量增长的话题。',
  'Compares data indicators and opinion trends of your game with competitors':
    '对比本游戏与竞品的各项数据指标、舆情走势',
  'Comparison Analysis': '对比分析',
  'Comparison Overview': '指标对比',
  'Comparison of Active Ads by Country': '分国家在投广告数投放对比',
  Competitor: '竞品',
  'Competitor Information and Comparison': '竞品舆情查看和对比',
  'Competitor KOL-AB': '竞品合作网红- AB',
  'Competitor KOL-CODM': '竞品合作网红- CODM',
  'Competitor KOL-FF': '竞品合作网红- FF',
  'Competitor KOL-MLBB': '竞品合作网红-MLBB',
  'Competitor KOL-Roblox': '竞品合作网红- roblox',
  Competitors: '竞品',
  'Competitors Ad Creatives': '竞品广告创意',
  'Competitors-1': '竞品游戏',
  'Completed (Crawled {count} comment)': '完成（已爬取 {count} 条评论）',
  'Completed (Crawled {count} comments)': '完成（已爬取 {count} 条评论）',
  Configuration: '配置',
  'Configuration-1': '配置页',
  Configured: '码表',
  Confirm: '确认',
  'Confirm Delete？': '确认删除？',
  Console: '主机游戏',
  'Contact {email} for assistance': '如有需要，请联系{email}',
  Contain: '包含',
  'Content Chinese': '帖子中译',
  'Content English': '帖子英译',
  'Content Original': '帖子原文',
  'Content must contain exactly "{text}", including spaces and punctuation.':
    '内容必须精准提及“{text}”，支持空格和各种标点',
  'Content must mention both “{text}” and “{text1}”': '内容必须同时提及“{text}”和“{text1}”',
  'Content must mention either “{text}” or exactly “{text1}”': '内容必须提及“{text}”或“{text1}”',
  'Content must mention exactly “{text}”': '内容必须提及“{text}”',
  'Content must mention “{text}” or “{text1}”': '内容必须提及“{text}”或“{text1}”',
  'Content scraped successfully, but no valid summary could be generated': '爬取内容无法生成有效AI总结',
  'Contextual Nearby Reviews': '帖子/评论的相邻内容',
  'Contribution to Change (%)': '波动贡献 (%)',
  'Contribution(↓)': '贡献度(↓)',
  'Copied failed': '复制失败',
  'Copied successfully': '复制成功',
  Copy: '复制',
  'Copy review': '复制评论',
  'Copy text': '复制内容',
  Core: '核心网红',
  'Core Function': '核心功能',
  'Core Overview': '核心概览',
  'Core: Brand-Related': '核心：品牌相关',
  Correlation: '相关度',
  Count: '数量',
  Country: '国家',
  'Country Distribution': '国家分布',
  'Country Settings': '国家维度',
  'Country data is only included if the hashtag is in its Top 100 within the selected time':
    '基于所选时间范围，获取每个国家在对应指标的前100个Hashtag。',
  'Crawling failed': '爬取失败',
  'Create Analysis': '生成分析报告',
  'Create Time': '创建时间',
  'Create failed': '创建失败',
  'Create success': '创建成功',
  'Create time': '创建时间',
  'Create time: {time}': '创建时间: {time}',
  'Creation Failed, please try again later': '创建失败，请稍后再试',
  'Creative Metrics': '素材指标',
  'Creative Trends': '素材热门趋势',
  Creatives: '创意',
  Creator: '创建者',
  'Creator Hub Incentive': '生态激励',
  Creators: '创作者',
  'Critic Reviews': 'Critic专业评论',
  'Critic Score': 'Critic 评分',
  'Critics Recommend%': '评论家推荐百分比',
  'Cross-Analysis': '交叉分析',
  'Cumulative Impressions': '累计曝光量',
  'Cumulative Impressions by Type': '在投广告累计互动量分互动类型',
  'Cumulative Trend': '累计趋势',
  'Current Period Mentions': '本周声量',
  'Current Period Mentions-1': '声量',
  'Current Report': '当前报告',
  'Current period': '本周期',
  'Current selected': '当前选中',
  'Current step failed. For any questions, please contact {email}.': '当前步骤失败，如有疑问请联系{email}。',
  'Currently, only global data comparisons are supported, if you need Google Trends Data for other countries/regions, please contact {contact}.':
    'Google Trends目前仅支持全球数据的比较，如果需要开通其他区域/国家，请联系{contact}',
  Custom: '自定义',
  'Custom AI Summary': '自定义AI总结',
  'Custom Analysis Time Range': '自定义时间区间',
  'Custom Input': '自定义输入',
  'Custom date range is not supported at this time for AI summaries.': '暂不支持自选日期AI总结',
  'Customer Reviews': '购买者评论',
  'Customer/User/Audience Reviews': '购买者/使用者/观众评论',
  Customize: '自定义',
  Customized: '自定义',
  'Customized Topic': '自定义话题',
  'Custom AI Summary': '自定义例行',
  DAU: '日活',
  Daily: '按日',
  'Daily Added Reviews': '日新增评论',
  'Daily Dashboard': '日粒度看板',
  'Daily Discuss Players': '舆情日活跃用户数',
  'Daily Engagement': '日互动量',
  'Daily Mentions': '日声量',
  'Daily Number of Creators': '日发帖人数量',
  'Daily Publications': '日发帖量',
  'Daily Report': '日报',
  'Daily Sentiment': '日均情感分',
  'Daily Trend': '日粒度趋势',
  'Daily Views': '日观看量',
  Danmu: '弹幕数',
  Dashboard: '经分',
  'Data Granularity': '数据粒度',
  'Data Map': '数据地图',
  'Data Selection:': '数据选择：',
  'Data Source': '数据源',
  'Data Source and Metrics': '查看舆情数据源及指标',
  'Data Source:': '数据来源:',
  'Data Update': '数据更新',
  'Data Update & Tags': '数据更新与打标',
  'Data Update: Not real-time data': '数据更新：非实时数据',
  'Data available after launch': '游戏上线后提供该数据',
  'Data available on the 31st day after launch': '游戏上线的第31天起，提供该数据',
  'Data from:': '数据来源：',
  'Data statistics are directly sourced from the Steam page': '直接来自Steam页面的数据统计',
  Date: '日期',
  'Date Duration': '近期时段',
  'Date Range': '时间范围',
  'Date-1': '发布日期',
  Day: '天',
  'Day-1': '日',
  Days: '天',
  'Days Active': '活跃天数',
  December: '十二月',
  'DeepSeek will take 1 to 3 minutes, depending on the content.': 'DeepSeek 将需要 1 到 3 分钟，具体取决于内容。',
  Default: '默认',
  'Default Date: Today': '默认日期：今日',
  'Default Sorting': '恢复默认排序',
  'Default prompt': '默认提示',
  Definition: '定义',
  'Definition Optimization:': '定义优化：',
  Delete: '删除',
  'Delete Analysis?': '删除分析报告？',
  'Delete Repeat Task?': '是否删除该例行报告',
  'Delete URL': '删除URL',
  'Delete failed': '删除失败',
  'Delete success': '删除成功',
  'Delete the filter setting': '删除筛选器方案',
  'Delete {name}? Deletion is irreversible, please proceed with caution.':
    '需要删除 {name}? 删除后报告不可恢复，请谨慎操作。',
  'Delete {name}{type}? Deletion is irreversible, please proceed with caution.':
    '删除{name}{type}吗？删除操作不可逆转，请谨慎进行。',
  'Demo:': '示例：',
  Des: '降序',
  Description: '说明',
  Detail: '详情',
  'Detailed feeds': '前往评论/资讯详情',
  Details: '详情',
  'Details Page': '直播详情页',
  'Details of Overseas All-Channel Opinions Feeds': '查看海外全渠道舆情Feeds详情',
  'Different Start Date (For Event Analysis)': '不同起始时间(事件分析)',
  'Digital Revenue': '线上收入',
  'Digital Revenue ($)': '线上收入 ($)',
  'Digital Units': '线上销量',
  Dimension: '维度',
  'Discord Chats': 'Discord讨论',
  Discussions: '讨论',
  Dislike: '点踩量',
  'Display 20 reviews from the same Official Account (if any)': '显示来自同一官号的20条评论(如果有)',
  'Display 20 reviews from the same official Account (if any)': '最多展示同官号的20条帖子/评论',
  'Display all reviewers including those in the list below': '显示所有发帖人，而非仅下方列表的发帖人',
  'Display top 10 topics by default': '默认展示声量排行前10的话题',
  Distance: '词距',
  Distribution: '分布',
  'Diverging Chart': '正负分布图',
  'Do you want to delete this article?': '是否删除此文章？',
  'Do you want to delete?': '是否删除该方案？',
  DoD: '日环比',
  "Don't save the edited content?": '放弃已编辑的内容？',
  Done: '完成',
  'Dot = Subtopic': '点 = 子话题',
  'Dot = Subtopic | X-axis = Weekly Mentions | Y-axis = Average Engagement (Mentions / Engagements) | Color = Report Type | Bubble Size = |WoW%| ↑ Increase ↓ Decrease':
    '点=子话题 | X=周声量 | Y=平均互动强度（声量/互动量）| 颜色= 举报类型 | 气泡大小=|WoW%| ↑上升 ↓下降',
  Download: '下载',
  'Download Image': '下载图片',
  'Download Original Comments': '下载原始评论',
  'Download PDF Document': '下载PDF文件',
  'Download Settings': '下载设置',
  'Download failed due to excessive data. We recommend exporting in batches or applying additional filters.':
    '下载失败，当前数据量过大。建议您分批导出或增加筛选条件。',
  'Download failed, please refresh the page': '下载失败，请刷新页面重试',
  'Download this report': '下载报告',
  Downloads: '下载',
  'Downloads exceed the {num} limit. Please adjust filters and retry.': '下载条数超 {num} 上限，请缩小筛选范围后重试。',
  'Download failed, please refresh the page.': '下载失败，请刷新页面',
  'Drill-down analysis is only supported for featured streamers and popular live streaming rooms.':
    '当前仅重点主播及热门直播间支持下钻分析',
  'Dual-Axis Comparison with Active Ads': '与在投广告数双轴对比',
  'Due to insufficient selected content, GPT is currently unable to summarize the report as requested.':
    '由于所选内容较少，GPT暂无法按要求总结报告。',
  'Due to the instability of the DeepSeek API, Deepseek is currently unable to summarize the report as requested.':
    '由于DeepSeek API不稳定，暂时无法总结报告，',
  'Due to the instability of the GPT API, GPT is currently unable to summarize the report as requested.':
    '由于GPT API不稳定，暂时无法总结报告，',
  'Due to the instability of the Gemini API, Gemini is currently unable to summarize the report as requested.':
    '由于Gemini API不稳定，暂时无法总结报告，',
  'Due to the small number of selected reviews, DeepSeek is currently unable to summarize the report as requested.':
    '由于所选评论较少，DeepSeek暂无法按要求总结报告。',
  'Due to the small number of selected reviews, GPT is currently unable to summarize the report as requested.':
    '由于所选评论较少，GPT暂无法按要求总结报告。',
  'Due to the small number of selected reviews, Gemini is currently unable to summarize the report as requested.':
    '由于所选评论较少，Gemini暂无法按要求总结报告。',
  Duration: '时间区间',
  'Duration-1': '直播时长',
  EMPTY: ' ',
  'Early Access Reviews': '早期体验',
  Earned: '玩家内容',
  'Earned Content': '玩家发帖',
  'Earned Content - Organic': '玩家发帖（非合作网红）',
  'Earned Content - Partnered': '玩家发帖（合作网红）',
  Edit: '编辑',
  'Edit Fail': '编辑遇到问题',
  'Edit Module': '编辑模块',
  'Edit My Following Games': '编辑我收藏的游戏',
  'Edit Name': '编辑标题',
  'Edit Prompt': '编辑Prompt',
  'Edit Repeat Settings': '编辑重复设置',
  'Edit Report': '修改报表',
  'Edit Success': '编辑成功',
  'Edit failed': '编辑失败',
  'Edit publish schedule for {day}': '编辑{day}发布日程',
  'Edit translation': '编辑译文',
  'Edit version': '编辑版本',
  'Editing History': '编辑历史',
  'Editing History': '编辑历史',
  'Effective Date': '生效时间',
  Email: '邮件',
  'Email Address': '邮箱地址',
  'Email Title': '邮件标题',
  'Email title must be filled in.': '邮件标题不可为空',
  Emerging: '突发',
  'Emerging Keywords': '突发关键字',
  "Emerging Keywords: Keywords that appear in the last hour, but haven't appeared in the last 3 or 5 days (Days of Game Store/ Monitoring Keywords/ Monitor Accounts are different), as Emerging keywords.":
    '突发关键字: 统计过去 1 个小时出现，但是过去 3 天或者 5 天没出现过的关键字（商店、监控关键字、监控官号来源的周期天数不同），作为游戏突发的关键字。',
  "Emerging Topic&Keywords：Based on the algorithm, Databrain identifies and tags the game's Emerging Keywords. Here are the top 30 Emerging Keywords in terms of Mentions, and topics aggregated based on these keywords.":
    '突发话题&关键字: Databrain 将根据算法，找出游戏突发的关键字并进行标记，此处展示前30个突发关键字，以及根据这些关键字聚合的突发话题。',
  'Emotion Amplification': '情绪放大',
  'Emotion Amplifying – High Attention Required': '情绪放大，重点关注',
  'Encountered an issue with the download. Please try again later or contact {contact} for assistance.':
    '下载遇到问题，请稍后重试或联系 {contact} 获取帮助。',
  'End Time': '结束时间',
  Engagement: '互动量',
  'Engagement Change%': '互动量环比',
  'Engagement Rate': '互动率',
  'Engagement by sentiment': '各情感分的互动量占比',
  'Engagement%': '互动率',
  'Engagement%-1': '互动量占比',
  'Engagement%: Change%': '互动率: 变化率',
  'Engagement-2': '按互动量',
  'Engagement-3': '互动量级',
  'Engagement: Change%': '互动量变化率',
  'Engagement: Summary of Likes, Comments and Shares of all Reviews (Posts & Comments).':
    '互动量：所有评论内容（主贴&回复）点赞量、评论量、转发量的汇总。',
  Engagements: '互动量',
  'Engagements (Likes + Shares + Comments)': '互动量 = 转赞评',
  English: '英文',
  'English Translation': '英文翻译',
  'English Translation Editing': '编辑英文翻译',
  'English Translation': '英文翻译',
  'English Translation Editing': '编辑英文翻译',
  'English Translation Editing History': '英文翻译历史',
  Enlarge: '放大',
  'Enter an English name or email address to search, then select and add from the drop-down list.':
    '输入英文名或邮箱搜索，从下拉列表中选择并添加',
  'Enter an integer greater than {min}.': '请输入大于{min}的整数。',
  'Enter custom keywords for exact-match or expand-match, supporting AND/OR relationships for precise filtering.':
    '请输入自定义关键字以实现精确匹配，支持使用【且】/【或】关系进行精准筛选。',
  Escalated: '已发酵',
  'Escalated – Immediate Action Required': '已发酵，必须介入处理',
  'Escalating Subtopics': '发酵子话题',
  'Estimated Cumulative Heat': '累计热度估值',
  Event: '事件',
  'Event Details': '事件详情',
  'Event List': '事件列表',
  'Event Summary': '事件总结',
  'Event Tracking': '事件追踪',
  'Event type': '事件类型',
  Events: '玩家讨论',
  'Events Setting': '事件设置',
  'Events-1': '事件',
  Everyone: '全员可见',
  'Exact Search': '精准搜索',
  'Exact Search: When we enter a keyword, the system will precisely match it in the original text, English translation, and Chinese translation of the reviews, excluding unrelated terms. For instance, if we enter "good," the system will only display reviews containing the exact word "good" in any of these versions, without including related terms like "better."':
    '精准搜索：通过键入文本去匹配评论的原文、英译和中译。排除所有非指定词汇的干扰。例如，若用户输入“good”，则系统只会显示命中了“good”一词原文、中文、英文的评论，而不会命中如“better”等其他相关词汇。',
  'Exact-match': '精准匹配',
  'Example：Bug; Issue': '举例：Bug; Issue',
  'Exceeds the maximum span of the currently selected version.': '超出当前所选版本的最长跨度',
  'Except for Steam, the remaining data is still being crawled, and the change rate is unreliable.':
    '除了steam外，其余数据仍在入库中，同环比数据不可靠',
  'Exchange position': '交换位置',
  Exclude: '排除',
  'Exclude Invalid': '去除无效内容',
  'Exclude Invalid Reviews': '去除无效评论',
  'Exclude Low & Invalid': '去除低有效及无效评论',
  'Exclude Neutral': '去除中性评论',
  'Exclude Only Contain': '排除仅包含',
  'Exclude unlabeled reviews': '过滤未分类的评论',
  Excluding: '未包含',
  'Execution Progress': '执行进度',
  'Executive Summary': '核心概览',
  'Expand All': '展开全部',
  'Expand all Tier 1 topic': '展开所有一级话题',
  'Expected to wait for 0.5h~2h': '预计等待0.5h~2h',
  'Expected to wait for 0.5h~2h,  depending on the content.': '预计等待0.5h~2h，具体取决于内容。',
  'Extended Search': '拓展搜索',
  'External Sources': '外部数据源',
  Failed: '失败',
  'Failed to fetch authentication information. If you have any questions, please contact {email}':
    '获取鉴权信息失败，如有疑问请联系{email}',
  'Failed to load video': '加载视频失败',
  'Failed to obtain authentication token. If you have any questions, please contact {email}':
    '获取鉴权token失败，如有疑问请联系{email}',
  'Failed to retrieve game information. If you have any questions, please contact {email}':
    '未获取到游戏信息，如有疑问请联系{email}',
  'Failed to retrieve report URL. If you have any questions, please contact {email}':
    '未获取到报表URL，如有疑问请联系{email}',
  'Failed to retrieve report information. If you have any questions, please contact {email}':
    '未获取到报表信息，如有疑问请联系{email}',
  'Failed to retrieve the files required for AI Chat; please contact {name} ({email}).':
    '目前AI Chat需要的文件获取失败，请联系{name}（{email}）。',
  'Favorite Page': '收藏的页面',
  Favorites: '收藏数',
  Featured: '重点关注',
  February: '二月',
  Feeds: '评论/资讯详情',
  'Feeds AI Summary': '评论 AI 总结',
  'Feeds GPT Summary': '评论GPT摘要',
  'Feeds/Reviews Detailed': '评论/资讯详情',
  'Filter Setting': '筛选方案',
  'Filter Setting Name': '筛选方案名称',
  'Filter Settings': '筛选项',
  'Filtered Avg. Rating': '已筛选评论平均评分',
  'Filtered Influencer': '已筛选的网红',
  'Filtered Positive%': '已选评论正面占比',
  'Filtered Rating': '已选评分',
  'Filtered Reviews': '已筛选的评论',
  'Filtered Total': '已筛选总数',
  'First Correlation Words': '一级相关词',
  'First Report Time Range:': '首份报告时间范围：',
  'First Seen': '发现时间',
  'First Seen-1': '首次发现时间',
  Fold: '收起',
  'Fold all Tier 1 topic': '收起所有一级话题',
  Follow: '收藏',
  'Follower Range': '粉丝量范围',
  'Follower/Subscriber': '粉丝量/订阅量',
  Followers: '粉丝量',
  'Followers (Top 50 AVG)': '平均粉丝数（排行前50）',
  'Followers Update: Only update the followers of opinion leaders with more than 5K followers or who post on that day.\nCalculation logic of daily views, likes and comments: Summarize posts on a daily basis, and count the data of these posts (such as views, likes and comments and engagement) as the views, likes, comments and engagement on the Posting day.\nInfluencers Data was updated from March 11, 2023.':
    '粉丝量更新：每日仅更新粉丝量大于 5 K或者当天有发帖的网红的粉丝量。\n每日观看、点赞、评论计算逻辑：按日汇总当天发的帖子数，统计这些帖子的数据（如观看、点赞、评论、互动）作为发帖日的观看、点赞、评论、互动。\n网红数据从2023-03-11开始更新。',
  "Followers difference of adjacent intervals: The difference is obtained by subtracting the followers data of the previous interval from the current interval. Negative numbers represent declines and positive numbers represent increases.\nFollowers' source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.":
    '粉丝增长量：通过本期时间的粉丝量减去上期时间的粉丝量获得差值，负数代表粉丝量下降，正数代表粉丝量上涨。\n各平台的粉丝量取值：Reddit 取自 Members，Youtube 取自 Subscribe，其他平台取自Followers。',
  'Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.':
    '各平台的粉丝量取值：Reddit 取自 Members，Youtube 取自 Subscribe，其他平台取自Followers。',
  'Followers(Top 10 AVG)': '平均粉丝量（排行前10）',
  'Followers/Subscribers': '粉丝量/订阅量',
  Following: '已收藏',
  'Free Played': '免费游玩',
  Frequency: '词频',
  'Frequency-2': '频率',
  Friday: '星期五',
  'From GPT-Translator. Powered by DataBrain NLP Team': '来自GPT-Translator，由DataBrain NLP团队提供技术支持',
  'From Google Translate': '来自谷歌翻译',
  "From the game's release on Steam to {time}, language statistics are directly derived from the Steam page":
    '从游戏在steam上发布到{time}, 直接来自Steam页面的语种统计',
  "From the game's release to {date}": '自游戏发布至{date}',
  'Funny(people)': '觉得有趣(人数)',
  'Fuzzy-match': '模糊匹配',
  'GPT Auto Report': 'GPT 智能报告',
  'GPT Options': 'GPT类型',
  'GPT Report is being generated.': 'GPT 报告生成中。',
  'GPT Reports': 'GPT报告\t',
  'GPT Settings': 'GPT 设置',
  'GPT Summary': 'GPT 总结',
  'GPT Summary: By Language': '分语种GPT总结',
  "GPT Summary: KOLs' Opinions": 'KOL观点GPT总结',
  'GPT will take 1 to 3 minutes, depending on the content.': 'GPT 将需要 1 到 3 分钟，具体取决于内容。',
  Game: '游戏',
  'Game (Sort by DAU)': '游戏 (按日活排序)',
  'Game Affinity': '游戏亲密度',
  'Game Analysis Name': '游戏报告名称',
  'Game Comparison Table': '游戏指标对比',
  'Game Duration(hours)': '游玩时长',
  'Game List': '游戏列表',
  'Game Performance Cross-Analysis': '游戏表现数据交叉分析',
  'Game Ranking List': '游戏排行列表',
  'Game Selection': '选择游戏',
  'Game Store': '游戏商店',
  'Game Store Reviews': '游戏商店评论',
  'Game Type': '支持游戏类型',
  'Game data is currently unavailable (due to unconfigured settings or lack of permissions). Please contact miamgao@tencent.com for assistance.':
    '暂无法查看该游戏数据（未配置或无权限）。如需帮助，请联系 miamgao@tencent.com。',
  'Game monitored': '监控游戏数量',
  Games: '游戏名',
  'Games Covered': '涵盖游戏',
  'Games-1': '游戏',
  'Gemini will take 1 to 3 minutes, depending on the content.': 'Gemini 将需要 1 到 3 分钟，具体取决于内容。',
  'General Game KOL': '多游戏网红',
  'General Summary': '基础总结',
  'Generate Analysis': '创建分析报告',
  'Generate Report': '创建报告',
  'Generate Summary': '生成总结',
  'Generate a summary of the opinions obtained. Highlight several most positive and negative topics, providing comprehensive examples for each. Conclude the report with a succinct executive summary. Please be as detailed as possible, and give examples of the comments.':
    '帮我生成一份目前所选评论的简要可执行的摘要报告，需要重点突出几个最积极和最消极的话题，并为每个话题提供具体的例子。最后以简洁的可执行的摘要来结束报告，需要尽可能详细，并提供相关的评论示例。',
  'Generate a summary of the opinions obtained. Highlight the three most positive and negative topics, providing comprehensive examples for each. Conclude the report with a succinct executive summary.':
    '帮我生成一份目前所选评论的简要可执行得摘要报告，需要重点突出三个最积极和最消极的话题，并为每个话题提供具体的例子。',
  'Generate and Repeat': '生成例行报告',
  'Generate and Repeat Settings': '创建报告并设置例行周期',
  Generating: '生成中',
  'Generating a summary now using Deepseek': '正在使用Deepseek生成总结',
  'Generating a summary now using GPT-4': '现在使用 GPT-4 生成摘要',
  'Generating a summary now using Gemini': '正在使用Gemini生成总结',
  'Generating a summary now using {name}': '正在使用 {name} 生成总结',
  'Generating summary by DeepSeek': '正在生成DeepSeek视频总结',
  'Generating summary by GPT4.0': '正在生成GPT4.0视频总结',
  'Generating summary by Gemini': '正在生成Gemini视频总结',
  Genre: '品类',
  'Genre Creator List': '品类网红列表',
  'Genre: Genre-Related': '品类：品类相关',
  'Get AI Summary': '生成 AI 总结',
  'Get GPT Summary': '生成 GPT 摘要',
  'Get the engagement metrics of the most popular videos and the number of followers the video creator has.':
    '查看最火的视频，互动量指标，以及创作者的粉丝量。',
  'Give UC': 'UC给予',
  Global: '全球',
  'Global Hero Summary': '东南亚区英雄',
  'Global data includes Influencer with no country/region defined.': '全球数据包括没有定义国家/地区的Influencer。',
  'Global except China mainland': '全球除中国大陆',
  'Global except China mainland refers to the reviews from game store and social media, that are collected from all regions/countries except China mainland, which cannot be distinguished from regions/countries.':
    '“全球（不包括中国大陆）” 表示来自游戏商店和社交媒体且都不是来自中国大陆，也无法区分具体的地区或国家的评论。',
  'Global includes reviews from game store and social media, which cannot be distinguished from regions/market.':
    '“全球”包括来自游戏商店和社交媒体，并且无法区分地区/市场的评论。',
  'Global official channel monitoring for real-time performance of content and accounts':
    '实时监测新媒体传播渠道，全面掌握视频、直播、网红、Hashtag、官号表现',
  'Global refers to the reviews from game store and social media, which cannot be distinguished from regions/countries.':
    '“全球” 表示来自游戏商店和社交媒体且无法按地区/国家进行区分的评论。',
  'Go to': '前往',
  'Go to AI Analysis Hub': '前往AI分析中心',
  'Go to AI Customized Summary': '前往自定义AI总结',
  'Go to Feeds': '前往评论/资讯详情页',
  'Go to Feeds page': '前往评论/资讯详情页',
  'Go to Key Opinions AI Analysis': '前往核心舆情AI分析',
  'Go to Official Account': '前往官号页',
  'Go to Reviews': '查看评论',
  'Go to Streaming page': '前往直播页',
  'Go to Video page': '前往视频页',
  "Go to influencer's homepage": '跳转网红主页',
  'Go to original URL': '前往源链接',
  'Go to original post': '跳转原帖',
  'Go to the line graph': '查看折线图',
  'Go to the original website (Steam).': '前往原官网（Steam）',
  "Go to the source website's personal homepage": '跳转源网站个人主页',
  'Google & Twitter Trends': '热搜',
  'Google & X Trends': 'Google & X 趋势',
  'Google Play': 'Google Play',
  'Google Play reviews identify countries by language': '谷歌市场评论通过语言来识别国家',
  'Google Trends': 'Google 趋势',
  'Grammar error': '语法错误',
  'Grammar is correct': '语法正确',
  'Growth of Followers': '粉丝增长量',
  Guidelines: '监控指南',
  Hashtag: 'Hashtag',
  'Hashtag AI Summary': 'Hashtag AI 总结',
  'Hashtag Details': 'Hashtag 详情',
  'Hashtag Trend (By Last {num} days)': 'Hashtag 趋势(例如近{num}天)',
  Hashtags: 'Hashtags',
  Healthy: '健康',
  Heat: '热度',
  'Heat Trend': '热度趋势',
  'Helpful(people)': '觉得有用(人数)',
  Hero: '英雄',
  'Hide comparison chart of column data. Comparison chart calculation method: Based on the maximum value of the column where the value resides,  use a bar chart to show the proportion of the value to the maximum value.':
    '隐藏列数据对比图示。对比方法：取当前列最大值作为参考，获得当指标占本列最大值的比例。',
  High: '高',
  'High & Middle Validation': '只看高&中有效性内容',
  'Highlight the scores of countries in which the declines exceed the threshold and need attention.':
    '突显下降超过阈值，需要关注的国家评分。',
  'Historical prompt': '历史记录',
  HoH: '小时环比',
  Hot: '热门',
  'Hot Content': '热门内容',
  'Hot Discussions': '热门讨论',
  'Hot Event': '热门事件',
  'Hot Events': '热门事件',
  'Hot Events: Events ranked in the Top 3 for three or more consecutive days':
    '热门事件：连续三天及以上位于Top3内的事件',
  'Hot Hashtags': '热门Hashtags',
  'Hot UGC Videos': 'UGC热门视频',
  'Hot event is being generated.': '热门事件正在生成中。',
  'Hot-2': '最热',
  'Hottest Time': '最热时间',
  Hour: '时',
  Hourly: '按小时',
  'Hourly Added Mentions': '小时新增声量',
  'Hourly Added Reviews': '小时新增评论',
  'Hourly Avg. Mentions': '小时平均声量',
  'Hourly Avg. Negative%': '小时平均负面声量占比',
  'Hourly Dashboard': '小时粒度看板',
  'Hourly Data Refresh': '小时实时刷新',
  'Hourly Discuss Players': '舆情小时活跃用户数',
  'Hourly Mentions': '小时声量',
  'Hourly Negative%': '小时负面声量占比',
  'Hourly Rising Keywords': '小时突增关键词',
  'Hourly data unavailable in this section.': '本模块暂不支持小时级数据。',
  'Hours Watched': '观看时长',
  'Hours Watched (hours)': '观看时长(小时)',
  'Hours Watched(hours)': '观看时长(小时)',
  ID: 'ID',
  'IEGG PR': 'IEGG PR',
  'IGN Video Report': 'IGN视频报告',
  'If necessary, please contact {contact}.': '如有需要请联系{contact}',
  'If three consecutive data reports generated based on the update frequency are not accessed, the reports will automatically stop':
    '如果按照更新频率连续生成的三份数据报告都未被访问，则报告会自动停止',
  'If you have any question, feel free to contact {contact}.': '如有疑问请联系{contact}。',
  Image: '图片',
  'Image Posts': '图片帖子',
  'Image download': '图片下载',
  Images: '图片',
  'Importance Editing History': '编辑重要性',
  Important: '重要性Top3',
  'Important Score-1': '按重要性得分',
  'Important Score-2': '重要性得分',
  Impressions: '曝光量',
  'In Total': '总和',
  'In data scraping': '数据爬取中',
  'In order to improve the computational efficiency, we selected the mentions of the top 200 keywords and their related synonyms as total mentions. The reviews list displays reviews related to that keyword and all its synonyms, which may be slightly more numerous than the keyword cards.':
    '为了提高计算效率，选取声量排名前200的关键字及其相关同义词的声量聚合。评论区显示与该关键字及其所有同义词相关的评论，数量可能略多于关键字卡片。',
  'In queue': '排队中',
  'In this section you can learn basic information about each data source in various dimensions.':
    '您可通过本章节了解舆情系统各类数据源的基本信息。',
  'In this section you can learn details about each metric in Opinions module.':
    '您可通过本章节了解舆情系统各指标的具体解释。',
  'In this section, all the news crawlers are listed out as below.': '本章节列出了所有的爬虫新闻源，如下所示。',
  Include: '包含',
  'Include Chitchat': '包含闲聊',
  'Including comments from game store and social media.': '评论来源于应用商店和社交媒体',
  'Including the following Tier 2 Topics': '包括以下二级话题',
  'Including video influencer and post influencer.': '包括视频网红 和文字帖网红。',
  Index: '热度',
  Influencer: '网红',
  'Influencer Counts': '网红数统计',
  'Influencer List': '网红列表',
  'Influencer Profile': '网红画像',
  Influencers: '网红',
  'Influencers type: include video influencers and post influencers. The list presents the head influencer from largest to smallest by the sum of the number of Engagements posted with video and text within the user statistical period.\nData sources: include influencers with 5,000 or more followers, and those who have posted in the selected time range on each platform.':
    '网红类型：包括视频网红和文字帖网红。列表默认按照用户统计时间段内发布的所有视频加文字贴的Engagement数量总和倒排呈现头部网红。\n网红数据来源：包括各平台粉丝量在5000及以上的网红，加上所选时间范围发过贴的网红。',
  'Influencers-1': '网红',
  'Influencers-2': '网红量',
  'Information overload, please reduce reviews and try again': '信息超载，请减少评论并重试',
  'Input Number': '输入数字',
  'Input relevant background knowledge or key focus areas here to generate a more tailored summary.':
    '输入相关的背景知识或重点关注领域，以便生成更加定制化的摘要。',
  'Insight Analysis': '洞察分析',
  Insights: '数据洞察',
  'Insights Report': '洞察报告',
  Intelligence: '情报',
  Intent: '意图',
  'Intent Distribution Trend': '意图分布趋势',
  Interval: '区间',
  'Introduces essential knowledge of Opinions, including data sources, terms, metrics, and calculations':
    '舆情数据源介绍，名词解释与指标计算逻辑',
  Invalid: '无效',
  'Invalid Filter': '评论有效性',
  'Invalid Reviews': '无效评论',
  'Invalid reviews are not supported for Chinese translation.': '无效评论当前暂不进行中文翻译。',
  'Items to be saved': '保存的筛选项',
  January: '一月',
  'Japan & Korea': '日韩',
  July: '七月',
  June: '六月',
  'Just Updated': '刚刚更新',
  'KOL Quotes': 'KOL观点',
  'KOL Region/Country': 'KOL 地区/国家',
  'KOLs Sort by {value}': '网红按{value}排序',
  'KPI Overview': '投放概览',
  'Key Country': '主要国家',
  'Key Metrics': '关键指标',
  'Key Metrics (Real-time)': '实时舆情',
  'Key Metrics Overview': '概览指标',
  'Key Metrics-1': '核心指标',
  'Key Opinions': '核心舆情',
  'Key Opinions AI Analysis': '核心舆情AI分析',
  'Key Opinions GPT Analysis': '核心舆情GPT分析',
  'Key Topic': '核心话题',
  'Key Topics': '核心话题',
  Keyword: '关键字',
  'Keyword & Topic Analysis': '关键字&话题分析',
  'Keyword & URL Analysis': '关键字 & URL分析',
  'Keyword Analysis': '关键字分析',
  'Keyword Correlation': '关联词',
  'Keyword Included': '包含的关键词',
  'Keyword Monitor': '监控关键字',
  'Keyword Related Reviews': '关键字相关评论',
  'Keyword Search': '关键字搜索',
  'Keyword mentioned frequency': '关键字提及次数',
  Keywords: '关键词',
  'Keywords &  words': '关键字和热词',
  'Keywords (Mentions)': '关键字（声量）',
  'Keywords Changes': '关键词变化',
  'Keywords Type': '关键字来源',
  'Keyword Subscriptions': '关键字例行',
  Language: '语种',
  'Language & Channel': '语种&渠道',
  'Language Distribution': '语种分布',
  'Language Distribution of Reviews': '评论语种分布',
  'Language Performance': '分语种表现',
  'Language Settings': '语种维度',
  'Language distribution is calculated using all videos entering the all-time Top 500 within the selected period.':
    '语种分布基于所选时段内、跻身历史观看量 Top 500 的所有视频数据计算',
  'Largest change contributor this week: {B} {A}. {B} {A}: {C}  change ({D} contribution).':
    '本周波动贡献率最高为{A}{B}，{A}{B}环比声量变化率 {C}  (波动贡献率{D})',
  Last: '最近',
  'Last 12 Months': '最近 12 个月',
  'Last 12 Weeks': '最近 12 周',
  'Last 180 Days': '最近 180 天',
  'Last 24 Months': '最近 24 个月',
  'Last 24 Weeks': '最近 24 周',
  'Last 3 Months': '最近 3 个月',
  'Last 30 Days': '最近 30 天',
  'Last 365 Days': '最近 365 天',
  'Last 4 Weeks': '最近 4 周',
  'Last 6 Months': '最近 6 个月',
  'Last 7 Days': '最近 7 天',
  'Last 90 Days': '最近 90 天',
  'Last Day Hourly Discuss Players': '前一天舆情小时活跃用户数',
  'Last Day Hourly Mentions': '前一天小时声量',
  'Last Day Hourly Negative%': '前一天小时负面声量占比',
  'Last Day Mentions': '前一天声量',
  'Last Generate Time': '近期生成时间',
  'Last Month': '上个月',
  'Last Seen': '最后发现时间',
  'Last Week': '上周',
  'Last Week-1': '上周数据',
  Latest: '最新',
  'Latest Analysis Task Progress': '最新分析任务进程',
  'Latest Update Time': '最新更新时间',
  Less: '收起',
  'Lifetime Accum. Rating': '历史累积评分',
  'Lifetime Added Reviews Positive%': '累计新增评论正面占比',
  'Lifetime Negative%': '历史累计负面评分占比',
  'Lifetime Rating': '历史累计评分',
  'Lifetime Recommended%': '累计推荐百分比',
  'Lifetime Reviews': '历史累积评分',
  'Lifetime Reviews-1': '历史累计评分量',
  'Lifetime User Score': '历史累积评分',
  'Lifetime. Rating & Reviews': '历史累计评分及评论数',
  Like: '点赞量',
  Likes: '点赞量',
  'Likes Change%': '点赞量环比',
  'Likes by sentiment': '各情感分的点赞量占比',
  'Line chart': '折线图',
  Link: '链接',
  'Live Broadcast Views': '直播观看量',
  'Live Charts Analysis': '直播弹幕分析',
  'Live Chats': '弹幕',
  'Live Chats Analysis': '直播弹幕分析',
  'Live Chats Sentiment': '弹幕情感分',
  'Live Chats in {language} Language': '{language}弹幕',
  'Live Chats on Streams': '直播弹幕',
  'Live Now': '正在直播',
  'Live Stream Start Time': '直播开始时间',
  'Live Stream Start Time for The Game': '本游戏直播开始时间',
  'Live Stream Time': '开播时间',
  'Live Streaming Content Analysis': '直播内容分析',
  'Live Today': '当日直播',
  'Live stream': '直播',
  Loading: '加载中',
  'Loading...': '加载中...',
  'Loading failed, please refresh the page.': '加载失败，请刷新页面',
  Low: '低',
  MAU: '月活',
  MR: 'MR',
  'Macro (500K-1M)': '中网红(500k ~ 1M)',
  'Macro(500k ~ 1M)': '中网红(500k ~ 1M)',
  Main: '主',
  'Main Change Tier 1 Topics': '主要变动一级话题',
  'Main Change Tier 2 Topics': '主要变动二级话题',
  'Main Change Topics': '主要变动话题',
  'Manual Edited Sentiment': '人工校正',
  March: '三月',
  Market: '市场',
  'Market Popularity Ranking': '市场热度排行\t',
  'Market Share by View': '观看量市场份额',
  'Market filter and Language filter are available. If you have any specific data calculation requirements, please feel free to contact {contact}.':
    '可提供 国家地区/语种 筛选器，具体数据计算需求联系 {contact}。',
  'Marketing Hub': '市场专区',
  'Mass KOL': '泛娱乐网红',
  'Max CCV': ' 直播观众峰值',
  May: '五月',
  Medium: '中',
  'Mega (1M+)': '大型网红(1M+)',
  'Mega(1M+)': '大型网红(1M+)',
  'Meme Details': '热梗详情',
  'Meme Elements': '热梗元素',
  'Meme Trend': '热梗趋势',
  'Meme Types': '热梗类型',
  Memes: '热梗',
  Mentions: '声量',
  'Mentions & Brand Health': '声量 & 品牌健康度',
  'Mentions & DAU REV DLS': '声量 & 日活 收入 下载',
  'Mentions & Engagement': '声量 & 互动量',
  'Mentions & Likes': '声量 & 点赞量',
  'Mentions & MAU REV DLS': '声量 & 月活 收入 下载',
  'Mentions & Negative%': '声量&负面声量占比',
  'Mentions & PCCV DigitalREV': '声量 &  直播观众峰值 线上收入',
  'Mentions & PCU DigitalREV Units': '声量 & 最高在线玩家 线上收入 销量',
  'Mentions & Sentiment': '声量 & 情感分',
  'Mentions & Sentiment Trends': '声量 & 情感分趋势',
  'Mentions & WAU REV DLS': '声量 & 周活 收入 下载',
  'Mentions (Security-Related) Trend': '舆情安全声量趋势',
  'Mentions ({dateType})': '声量（{dateType}）',
  'Mentions / DAU': '声量/日活',
  'Mentions / MAU': '声量/月活',
  'Mentions / WAU': '声量/周活',
  'Mentions Top 15 Topics': '声量前15话题',
  'Mentions Top {top}': '前{top}的声量',
  'Mentions Trend by Channel': '分渠道声量趋势',
  'Mentions Trend by Language': '分语言声量趋势',
  'Mentions by Subtopic': '分子话题声量',
  'Mentions by Topic': '分举报类型声量',
  'Mentions by sentiment': '各情感分的声量占比',
  'Mentions%': '声量占比',
  'Mentions%: Change%': '声量占比变化率',
  'Mentions(change%)': '声量 (变化率%)',
  'Mentions: Change%': '声量变化率',
  'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the App Store, as well as reviews captured on social media through monitor words and official accounts.':
    '声量：全网抓取到的玩家帖子和评论数汇总。包括游戏在游戏商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论。',
  'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the Game Store, as well as reviews captured on Social Media through monitor keywords and official accounts.':
    '声量：全网抓取到的玩家帖子和评论数汇总。包括游戏在游戏商店下的所有评论，以及通过监控词和官号在社交媒体上抓取到的评论。',
  'Mentions: not dedupilcated': '声量统计时未对同义关键字的评论去重',
  'Menu mismatch detected. If you have any questions, please contact {email}': '未匹配到菜单，如有疑问请联系{email}',
  Metascore: 'Meta评分',
  Metric: '指标',
  'Metric splitting not supported': '该指标不支持拆分',
  'Metric/Engagement': '指标/模块',
  Metrics: '指标',
  'Metrics Set': '指标集',
  'Metrics Settings': '指标设置',
  'Metrics Table for Download': '指标统计及下载',
  'Micro (10K-50K)': '微网红(10k ~ 50k)',
  'Micro(10k ~ 50k)': '微网红(10k ~ 50k)',
  'Mid-Tier (50K-500K)': '小网红(50k ~ 500k)',
  'Mid-Tier(50k ~ 500k)': '小网红(50k ~ 500k)',
  'Min Correlation': '最小相关度',
  'Min Frequency': '最小词频',
  Mixed: '褒贬不一',
  'Mixed%': '褒贬不一声量占比',
  'Mixed-1': '中性',
  MoM: '月环比',
  Mobile: '手游',
  'Mobile Games': '移动端游戏',
  Mode: '模式',
  Module: '模块',
  'Module Name': '模块名称',
  Monday: '星期一',
  'Monitor Account': '监控官号',
  'Monitor Method': '监控方式',
  'Monitor Scope': '监控范围',
  'Monitor Source': '监控源',
  'Monitor Way': '监控方式',
  'Monitor Way: The opinion content from social media sources is obtained by crawlers through pre-configured monitoring keywords and monitoring social media accounts.\n\nKeyword Monitoring: Comments(Posts only) obtained by searching keywords on social media.\n\nAccount Monitoring: Comments(Posts&Replies) obtained by monitoring official accounts on social media.\n\nTopic: Divide comments into topics through the rules or algorithms.':
    '监控方式：社媒来源的舆情内容，是爬虫通过预先配置的监控关键字和监控的社媒官号爬取获得。\n\n监控关键字：在社交媒体通过搜索此关键字获取的评论内容（主贴）。\n\n监控官号：在社交媒体获取此官号下的所有评论内容（主贴&回复）。\n\n话题：通过游戏设定的规则或算法将评论划分至某个话题。',
  'Monitoring Source': '监控来源',
  Month: '月',
  'Month-1': '月',
  Monthly: '按月',
  'Monthly Avg. DAU': '月日均DAU',
  'Monthly Avg. Download': '月均下载',
  'Monthly Comment update': '月更新评论数',
  'Monthly Returning': '月度回流',
  Months: '个月',
  More: '更多',
  'More Filters': '更多选项',
  'More Posts': '查看更多',
  'More competitors will be added in the future.': '更多竞品正在准备中',
  'More than {days} days, till {time}': '超过{days}天，直至{time}',
  'Most Valuable': '最具价值',
  'Mostly Negative': '多半差评',
  'Mostly Positive': '多半好评',
  'Multi-Gamer': '多游戏网红',
  'Multiple words are separated by “;” .': '多个关键字按 “;” 拆分.',
  'Must Have Keywords': '必选关键字',
  'Must be an integer.': '必须为整数',
  'My Filter': '我的筛选方案',
  'My Following': '我的收藏',
  'My Related': '我的游戏',
  'My Reports': '我的报表',
  'My Reports-1': '我的报告',
  'NLP Generated': 'NLP自动生成',
  'NLP Tag': 'NLP识别',
  'Nano (1-10K)': '纳米网红(1K ~ 10K)',
  'Nano(1K ~ 10K)': '纳米网红(1K ~ 10K)',
  'Natural Language Search': '自然语言搜索',
  'Natural Language Search Subscriptions': '自然语言搜索例行',
  'Nearly {n} Hours': '近{n}小时',
  Negative: '负面',
  'Negative Articles': '负面新闻数',
  'Negative Content': '负面内容',
  'Negative Mentions': '负面声量',
  'Negative Ratio': '负面比例',
  'Negative Reviews': '负面评论数',
  'Negative Topic': '负面话题',
  'Negative%': '负面占比',
  'Negative%-2': '负面声量占比',
  'Negative%-2: Change%': '负面声量占比变化率',
  'Net Sentiment': '修正情感分',
  'Network connection seems unstable. Please check your network settings or try again later.':
    '网络连接似乎有些不稳定，请检查网络设置或稍后重试。',
  Neutral: '中性',
  'Neutral Articles': '中性新闻数',
  'Neutral%': '中性占比',
  'Neutral%-2': '中性声量占比',
  'Neutral%-2: Change%': '中性声量占比变化率',
  New: '新增',
  'New Ads': '新增广告数',
  'New Creatives': '新增素材数',
  'New Event': '新事件',
  'New Event: Events occurring for the first time within 30 Days': '新事件：近30天内首次出现的事件',
  'New Prompt Applied': '已应用新提示内容',
  News: '新闻',
  'News Crawl Strategy': '新闻爬取策略',
  'News Crawlers': '新闻源',
  'News Crawling Strategy': '新闻爬取策略',
  'News Media': '新闻资讯',
  'News Mentions': '新闻量',
  'News Mentions & Sentiment': '新闻量&情感分',
  'News crawling strategy: the crawler will use the game name & game alias to pair [news title] instead of [news title + content], the news whose title hits the game name will enter this game news database.':
    '新闻爬取策略：爬虫将使用游戏名&游戏别名去配对【新闻标题】而非【新闻标题+内容】，标题命中游戏名称的新闻将进入本游戏新闻数据库。',
  'News-1': '新闻量',
  'News-2': '新闻媒体',
  Newsletter: '洞察报告',
  Next: '下一步',
  'Next Star': '招募网红',
  'Next report will be generated in {name}': '下份报告将{name}后生成',
  Nikke: '角色',
  No: '否',
  'No Citation': '暂无注解',
  'No Data under the current filter settings.': '该筛选条件下无数据',
  'No GPT Report under current filter settings.': '当前筛选条件下暂无GPT报告。',
  'No Keywords': '暂无关键字',
  'No New Data': '暂无新数据',
  'No Steam data under current filter selections': '当前筛选条件下暂无Steam数据',
  'No Steam data yet': '暂无Steam数据',
  'No Tag': '暂无标签',
  'No Tags': '其他网红',
  'No Title': '无标题',
  'No URL': '无链接',
  'No citation yet': '暂无注解',
  'No comments yet.': '本贴暂无评论。',
  'No data': '暂无数据',
  'No data available for the selected period': '所选时间范围内暂无数据',
  'No data for the current selection.': '当前条件下暂无数据',
  'No data to load': '无数据',
  'No data under current filter selections': '当前选项下无数据',
  'No data under current filter selections.': '当前选项下无数据',
  'No data under current selections.': '当前选项下暂无数据。 ',
  'No data under the current filter settings.': '该筛选条件下无数据。',
  'No data yet': '暂无数据',
  'No data yet.': '暂无数据',
  'No entities found by current keyword': '当前输入内容暂无搜索结果',
  'No filter available': '暂无方案',
  'No insight report has been created yet.': '尚未创建洞察报告。',
  'No more topics showed an increase': '暂无其他增长的话题',
  'No more topics showed an increase in mentions': '暂无其他声量增长的话题',
  'No more topics showed an increase in the indicator': '没有其他话题显示出增长的趋势',
  'No permission currently': '暂无权限',
  'No result found': '无匹配项',
  'No reviews have been crawled for this platform': '暂未爬取该平台评论',
  'No sentiment score': '未评分',
  'No summary available yet': '暂未生成总结内容',
  'No topics showed an increase in mentions compared to the following periods': '对比以下时段，暂无声量增长的话题',
  'No topics showed an increase in the indicator compared to the following periods': '对比以下时段，暂无增长的话题',
  'Non Negative %: The proportion of Positive and Neutral sentiment Reviews in total Reviews (Posts & Comments).':
    '非负情感占比：正面+中性情感声量在总声量中的占比。',
  'Non Negative%': '非负情感占比',
  'Non-official Account': '非官号',
  'Non-streaming Influencers': '非直播类网红',
  None: '未选择',
  'None-1': '无',
  'North America': '北美',
  'Not Recommended': '不推荐',
  'Not Released': '未上线',
  'Not yet edited': '暂未编辑情感分',
  Note: '注解',
  'Note: Format restrictions or specific template requests may cause processing issues.':
    '注意：格式限制或特定模板请求可能会导致处理问题。',
  'Note: The extended search currently only supports the "OR" search, which is the input of the ";" symbol.':
    '注：拓展搜索当前仅支持【或】搜索，即“；”符号的输入。',
  Notice: '提示',
  'Not Recommended': '不推荐',
  Noun: '名词',
  November: '十一月',
  'Number of Creators': '全网发帖人数',
  'Number of Creators-1': '发帖人数',
  'Number of Live Chats': '弹幕数量',
  'Number of Live Chats-1': '累计弹幕数量',
  'Number of Reported Players': '被举报的玩家数',
  'Number of Reviews': '总评论数',
  October: '十月',
  'Official Account': '官号发帖',
  'Official Account Data Performance': '官号数据表现',
  'Official Account Followers': '官号粉丝量',
  'Official Account Performance Trends by Channel': '官号分渠道表现趋势',
  'Official Account User Comment Analysis': '官号用户评论分析',
  'Official Account User Feedback Analysis': '官号用户反馈分析',
  'Official Account VS Earned': '官号内容 VS 玩家内容',
  'Official Account Views': '官方播放量',
  'Official Account-1': '官号内容',
  'Official Accounts': '官方账号',
  'Official Accounts Performance': '官号数据表现',
  'Official Engagement': '官方互动量',
  'Official Engagement Rate': '官方互动率',
  'Official Potential Impressions': '官方曝光量',
  'Official Potential Impressions-1': '官方潜在曝光',
  'Official platform rating': '官方平台评分',
  'On Record Time': '总游玩时长',
  'Once the newsletter is updated, we will notify you by email.': '报告更新后，我们将在第一时间为您推送至邮箱。',
  'Once the report is created, the system will periodically update it automatically.\nPlease contact {email} if you need to create a periodic report.':
    '创建后，系统将周期性自动更新报告内容。\n如需创建报告，请联系{email}',
  'One-time Summary({total})': '一次性总结({total})',
  'Only 20 URLs can be added': '仅支持添加20个URL',
  'Only Contain': '仅包含',
  'Only Exclude': '仅排除',
  'Only High Validation': '只看高有效性内容',
  'Only Include': '仅包含',
  'Only Me': '仅自己',
  'Only counts original keywords': '仅统计原始关键字',
  'Only original keywords are counted': '仅统计原始关键字',
  'Only single-day data summaries are supported.': '目前仅支持单日数据总结',
  'Only supports URLs within the last 90 days. Please reselect the date':
    '仅支持查询90天内发布的帖子URL，请重新选择时间',
  'Only time ranges of 30 days or less are supported.': '时间跨度（开始至结束）不能超过30天。',
  'Only you can view this report': '只有你自己可以查看',
  'Opencritic/Metacritic Review Type': 'Opencritic/Metacritic 评论类型',
  Operation: '操作',
  'Operation Metrics': '运营指标',
  'Operation Success': '操作成功',
  Opinions: '舆情',
  'Opinions Highlights': '舆情动态',
  'Opinions Introduction': '舆情介绍',
  'Opinions Metrics': '舆情指标',
  'Opinions Overview': '舆情概览',
  'Opinions Scources': '舆情数据源',
  'Opinions Sources': '舆情数据源',
  'Opinions Summary': '舆情观点概要',
  Optional: '选填',
  'Optional keywords': '候选关键字',
  'Optional. If left blank, the pre-trained prompt provided by DataBrain will be used; alternatively, you can enter text to redefine the output format or further constrain the content of the summary.':
    '选填。不输入内容的话会使用DataBrain已经训练好的Prompt，您也可以输入内容来重新设定输出的格式或者进一步限制总结的内容。',
  Order: '排序',
  Organic: '非合作网红',
  Original: '源语种',
  'Original Content': '源语种内容',
  'Original Language': '源语种',
  'Original Post': '评论所属主贴',
  'Original Report': '初始报告',
  'Original URL': '示例链接',
  'Original Content': '源文本',
  'Other KOLs': '其他网红',
  'Other Settings': '其他选项',
  'Other Topics': '其他话题',
  'Other topics': '其他话题',
  'Other videos': '其他视频',
  Others: '其他',
  'Output an opinion summary in English with no more than 300 words': '输出不超过300字的中文摘要',
  Overall: '全部',
  'Overall Brand Health': '总品牌健康度',
  'Overall Performance': '整体表现',
  'Overall Sentiment': '总情感分',
  'Overall summary for the selected time period': '所选时段整体总计',
  Overview: '概览',
  'Overview Metrics': '核心指标概览',
  'Overview Table': '热度趋势',
  'Overview of Opinions Data and Hot Topics': '今日舆情数据和热点内容一览',
  'Overwhelmingly Negative': '差评如潮',
  'Overwhelmingly Positive': '好评如潮',
  PC: '端游',
  'PC/Console Games': 'PC/主机游戏',
  PCU: '同时最高在线玩家',
  PCV: '直播观众峰值',
  PR: 'PR',
  'PUBGM Active': 'PUBGM活跃网红',
  'PUBGM Esports Player': 'PUBGM电竞网红',
  'PUBGM Partnered': 'PUBGM合作网红',
  'PUBGM Potential': 'PUBGM潜力网红',
  PV: 'PV',
  Paid: '付费',
  'Parent Comment Id': '主贴ID',
  'Parent Comment Url': '主贴URL',
  'Part-of-speech': '词性',
  Partnered: '合作网红',
  'Partnered%': '已合作%',
  'Partnered/Total': '合作数/总数',
  'Past 5-week Average': '过去五周均值',
  Patch: '热更/补丁',
  'Patch/Version': '版本',
  'Peak CCV': ' 直播观众峰值',
  'Peak CCV (Peak concurrent viewers): The daily peak viewers of the live stream is calculated according to the selected time range, and the maximum value of these days is taken as Peak CCV.':
    ' 直播观众峰值：根据所选的时间范围，计算本游戏每日直播观众的峰值，取其中的最大值作为观看用户峰值。',
  'Peak CCV (Peak concurrent viewers): take the peak value of viewers watching the stream live.':
    ' 直播观众峰值：观看直播的观众峰值。',
  'Peak Index': '热点',
  'Percentage of Official Posts': '官方发帖量占比',
  'Percentage of UGC Posts': 'UGC发帖量占比',
  Performance: '指数',
  'Performance Analysis': '表现分析',
  'Performance-1': '网红总体表现',
  Period: '周期',
  Permissions: '权限',
  'Pie chart': '饼图',
  Platform: '平台',
  'Playback Time': '开播时长',
  'Player Feedback': '玩家反馈',
  'Players&Viewers': '玩家人数&观看人数',
  'Playtime on Record': '游戏总时长',
  'Please Input The Citation': '请输入注解内容',
  'Please choose an edition first.': '请选择一个版本',
  'Please click <a>[Edit]</a> to follow games.': '点击 <a>【编辑】</a> 按钮可收藏游戏',
  'Please contact @{contact}({email}) for configuration': '配置监控范围请联系@{contact}({email}) ',
  'Please do not close the tabs during the download process.': '下载过程中请不要关闭选项卡。',
  'Please do not close this page - download.': '下载过程中，请勿关闭页面',
  'Please do not close this page.': '请不要关闭此页面。',
  'Please enter': '请输入',
  'Please enter a Email': '请输入邮箱',
  'Please enter a name': '请输入方案名',
  'Please enter a name for report': '请输入报告标题',
  'Please enter a name for this report': '请输入报告标题',
  'Please enter a numerical value to three decimal places.': '请输入小数点后三位的数值。',
  'Please enter a report name': '请输入报告名称',
  'Please enter correct date': '请输入正确的日期范围',
  'Please enter email title.': '请输入邮件标题',
  'Please enter in the following format: Tags: keywords, keywords; Tags: keywords, keywords. Use (;) to separate tags, and do not use (;) at the end of the last tag.':
    '请按照格式输入: 标签:关键词,关键词;标签:关键词,关键词。标签之间使用使用 ( ; ) 分割,最后一个标签的结尾不需要( ; )',
  'Please enter keywords according to the format requirements': '请按格式要求输入关键词',
  'Please enter name': '请输入报告名称',
  'Please enter numbers, symbols are not supported.': '请输入数字，不支持输入符号。',
  'Please enter prompt.': '请输入提示',
  'Please enter tags according to the format requirements': '请按格式要求输入标签',
  'Please enter the correct email address': '请输入正确格式的邮箱',
  'Please enter the module name': '请输入模块名称',
  'Please enter the translation': '请输入译文',
  'Please enter the version name': '请输入版本名称',
  'Please fill in': '请填写',
  'Please input a name for this report': '请输入本报表名称',
  'Please input the tag': '请输入标签名',
  'Please input the {topic_name} and {topic_definition} here. These two fields are compulsory. Additionally, you may choose to provide some keywords and example sentences related to the topic; these two fields are optional.':
    '请输入{topic_name}和{topic_definition}，这两项为必填字段。此外，您可以选择提供相关的关键词和示例句子，这两项为可选字段。',
  'Please modify before submitting': '请勿提交相同选项',
  'Please re-select the filter': '请重新选择筛选条件',
  'Please reserve a sentiment icon': '请保留1个情感选项',
  'Please reserve one option': '请保留1个选项',
  'Please retry after changing the filter conditions.': '请更换筛选条件后重试。',
  'Please search and select the Steam ID': 'Steam ID较多，请搜索后选择Steam ID',
  'Please search and select the keywords': '关键字较多，请搜索后选择关键字',
  'Please search and select the reviewer': '发帖人较多，请搜索后选择发帖人',
  'Please search and then select a URL': '请搜索后选中一条URL',
  'Please select a Tag': '请选择一个标签',
  'Please select a game': '请选择一款游戏',
  'Please select a metric': '请选择一个指标',
  'Please select a time range within {N} days': '请选择{N}天以内的时间范围',
  'Please select at least one game': '请先选择至少一款游戏',
  'Please select the time range within 3 year. Feel free to contact {contact} if needed':
    '过多数据将导致查询变慢，选择时间跨度请勿超过3年。如需统计1年以上的数据请联系{contact}.',
  'Please select {count} items at most for the best visualization experience.':
    '为了更好的图表视觉体验，请选择{count}项以内的网红',
  'Please try again later.': '请稍后重试。',
  'Please try again tomorrow or contact {name} for more usage.': '请明天再申请报告，或联系{name}获取更多帮助。',
  'Please try another keyword or search on other tables for the information you are looking for.':
    '请输入其他关键字或者在其他表单搜索该内容',
  Popular: '热门筛选',
  Popularity: '热度',
  Position: '关联词位置',
  Positive: '正面',
  'Positive Articles': '正面新闻数',
  'Positive Content': '正面内容',
  'Positive Mentions': '正面声量',
  'Positive Ratio': '正面比例',
  'Positive Reviews': '正面评论数',
  'Positive Topic': '正面话题',
  'Positive and': '正面和',
  'Positive%': '正面占比',
  'Positive% & Negative%': '正面&负面声量占比',
  'Positive% Difference': '正面占比差值',
  'Positive% by Language': '分语种正面占比',
  'Positive%-2': '正面声量占比',
  'Positive%-2: Change%': '正面声量占比变化率',
  'Positive%-3': '好评率%',
  'Post Analysis': '主贴分析',
  'Post Comments': '图文贴评论量',
  'Post Count': '帖子发帖量',
  'Post Engagement': '主贴互动量',
  'Post Engagements': '图文贴互动量',
  'Post Influencers': '图文类网红',
  'Post Likes': '图文贴评论量',
  'Post Publications': '图文贴发帖量',
  'Post Share': '图文贴分享量',
  'Post Views': '图文贴观看量',
  'Posting Time': '发帖时间',
  'Postive% by Language': '分语种正面占比',
  Posts: '主贴',
  'Posts & Comments': '主贴和评论',
  'Posts-1': '发帖量',
  'Posts-2': '图文主贴',
  Potential: '潜力网红',
  'Potential Impressions': '全网潜在曝光量',
  'Potential Impressions-1': '潜在曝光量',
  'Potential Reach': '曝光量',
  'Powered by iMarketing, contact bourneli@global.tencent.com for further questions':
    '直播分析页由iMarketing提供技术支持，可联系bourneli@global.tencent.com了解更多',
  'Pre-configured': '预配置码表',
  'Pre-configured & NLP Algorithms': '预配置码表&NLP算法词库',
  'Predicted DAU': '预测日活',
  'Predicted Download': '预测下载',
  'Predicted MAU': '预测月活',
  'Predicted Revenue': '预测收入',
  'Predicted WAU': '预测周活',
  'Preparing the summary task': '正在准备总结任务',
  "Pressing 'Enter' will return.": '点击[回车键]返回',
  'Pressing ‘Enter’ will return': '点Enter键返回',
  'Pressing ‘Enter’ will return to the original list.': '点击[Enter]键，回到原评论列表。',
  Preview: '示例页面图片',
  Previous: '上一步',
  'Previous Period Mentions': '上周声量',
  'Previous Period Mentions-1': '上期声量',
  'Previous period': '上周期',
  'Private Discord': '内部Discord',
  'Private Source': '私密渠道',
  Processing: '处理中',
  Promoted: '推广',
  Prompt: '提示',
  'Prompt Modification': 'Prompt修改',
  'Prompt Name': 'Prompt名称',
  'Prompt Setting': '提示词设置',
  'Prompt deleted successfully': 'Prompt已成功删除',
  'Prompt edit failed': '提示词编辑失败',
  'Prompt edit successful': '提示词编辑成功',
  'Prompt save failed': 'Prompt保存失败',
  'Prompt saved successfully': 'Prompt已成功保存',
  'Prompt updated successfully': 'Prompt已成功更新',
  Prompts: 'Prompts',
  'Provides insights into overall game ratings and changes in game stores worldwide':
    '了解游戏在所有国家/地区的应用商店整体评分和异动情况 ',
  Publication: '全网发帖量',
  'Publication Counts': '发帖数统计',
  Publications: '发帖量',
  'Publish Calendar': '发布日历',
  'Published Time': '发布时间',
  'Publishing Performance': '帖子表现',
  'Purchase Analysis': '购买行为分析',
  'Quality Check:': '质量检查：',
  'Quarterly Returning': '季度回流',
  Query: '提问',
  'Questionnaire Feedback': '问卷主观题分析',
  Quick: '快速总结',
  'Quick — faster, with fewer opinions and rougher numbers.': '快速总结—速度较快，观点与数据分析结果较为简略',
  'Quick-1': '快捷选项',
  Rank: '排名',
  'Rank Change': '排名变化',
  'Ranked By': '按排序',
  'Ranked By {value}': '按{value}排序',
  Rate: '比例',
  Rating: '星级',
  'Rating Difference': '评分差值',
  'Rating Reviews': '评分评论量',
  'Rating Settings': '星级维度',
  'Rating-1': '评分',
  'Rating-2': '评分数',
  'Rating-2%': '评分%',
  Ratings: '评分',
  'Ratings by Language': '分语种评分统计',
  'Ratings-1': '条评分',
  'Ratings-2': '评论量',
  Reach: '曝光量',
  'Reactions-1': '用户回应',
  'Real examples/keywords': '实际案例/关键词',
  'Real-Time AI Summary': '实时AI总结',
  'Real-Time Ratings Across Global Game Stores': '各国商店评分实时展示',
  'Real-time Opinions': '实时舆情',
  'Real-time Streaming': '实时直播分析',
  'Real-time Streaming Analysis': '实时直播分析',
  'Real-time Trend Analysis': '实时趋势分析',
  'Real-time monitoring of worldwide social media, game stores, and news media':
    '对社交媒体、应用商店、新闻舆情进行7*24小时全时段实时监测',
  'Realtime Accumulated Steam Reviews(1h)': '实时Steam累计评论（一小时）',
  'Realtime Newly Added': '实时新增',
  'Realtime Ratings': '实时商店评分',
  'Realtime Steam Reviews': '实时Steam评论',
  Reason: '理由',
  'Receiver Email': '收件人邮箱',
  'Recent Accum. Rating': '近三十天累计评分',
  'Recent Recommended%': '近三十天推荐百分比',
  'Recent Reviews': '近期评论',
  'Recent Reviews Positive%': '近期评论（正面%）',
  'Recent Reviews Positive%-1': '近期评论正面%',
  'Recent Top News': '近期热点新闻',
  'Recent Viewed': '最近浏览',
  Recommend: '推荐',
  Recommended: '推荐',
  'Recommended%': '推荐百分比',
  'Recommended%-1': '推荐%',
  'Refine topic definitions based on real game data': '基于游戏真实数据优化话题定义',
  'Refreshed every 30 Mins, the first summary is being generated.': '每30分钟刷新一次，正在生成第一份总结内容',
  'Refund Game': '游戏退款',
  Refunded: '退款',
  Regenerate: '重新生成',
  'Regenerate AI Summary': '重新生成 AI 总结',
  'Regenerate GPT Summary': '重新生成GPT总结',
  Region: '地区',
  'Region / Country': '地区/国家',
  'Region/Country': '地区/国家',
  'Regular Listening': '例行监听',
  'Related Ads': '相关广告',
  'Related Creatives': '相关素材',
  'Related Hashtags': '相关Hashtag',
  'Related Links': '相关链接',
  'Related News': '相关新闻',
  'Related Queries': '相关搜索',
  'Related Topic': '相关话题',
  'Related Topics': '相关话题',
  'Related Twitter': '相关推文',
  'Related Videos': '相关视频',
  'Related keywords': '相关关键字',
  'Related to the Game': '游戏相关',
  Release: '上线',
  'Release Date': '上线日期',
  'Release Days': '上线时长',
  'Release Time': '上线时间',
  'Release-1': '正式版',
  Relevance: '相关度',
  Remarks: '备注',
  'Remove contrast item': '移除该游戏',
  'Remove from Favorites': '移除该报表',
  'Remove this game': '移除该游戏',
  'Removed duplicate reviews': '评论已去重',
  'Repeat Date Range': '例行时间范围',
  'Repeat End Time': '例行报告结束时间',
  'Repeat every {number} {dateType}, data spans from 00:00 on the first day of Month 1 to 00:00 on the first day of Month {totalDiff}':
    '每{number}{dateType}重复，数据范围从第1月第1天 00:00 到第{totalDiff}月第1天 00:00',
  'Repeat every {number} {dateType}, data spans from 00:00 on {dateTypeText} 1 to 00:00 on {dateTypeText} {totalDiff}':
    '每{number}{dateType}例行，数据从第1{dateTypeText} 00:00到第{totalDiff}{dateTypeText} 00:00',
  'Repeat every {number} {hour}': '每{number}{hour}例行',
  'Replace current prompt?': '替换当前Prompt',
  'Replacing it with "{title}" will lose the current text.': '使用"{title}"代替输入将丢失当前内容',
  Replies: '评论量',
  Report: '报表',
  'Report Language': '报告语言',
  'Report Name': '报告名称',
  'Report Start Time': '报告开始时间',
  'Report Text': '举报文本',
  'Report Text in Chinese': '中文举报文本',
  'Report Text in English': '英文举报文本',
  'Report Time': '举报时间',
  'Report Type': '报告类型',
  'Report generation failed. Please contact {email}.': '报告创建失败，请联系{email}。',
  'Report generation success.': '报告生成成功',
  'Report image download failed. Please refresh the page and try again.': '报告图片下载失败，请刷新页面后重试。',
  'Report link copied': '已复制报告链接',
  'Report permissions have been successfully adjusted.': '报告权限已调整成功',
  'Report visibility has been set to "Visible only to me"; click {permission} to adjust.':
    '报告权限已调整为仅自己可见，如需调整可点击{permission}',
  'Report visibility has been set to "Visible to everyone"; click {permission} to adjust.':
    '报告权限已调整为全员可见，如需调整可点击{permission}',
  'Report visibility has been set to "Visible to selected users"; click {permission} to adjust.':
    '报告权限已调整为部分用户可见，如需调整可点击{permission}',
  Reportopenid: '举报Openid',
  'Representative Reviews': '代表性评论',
  Reset: '重置',
  'Reset summary failed': '总结报告重置失败',
  'Reset summary success': '总结报告重置成功',
  'Result Output': '结果输出',
  Revenue: '收入',
  'Revert to original report': '重置为初始报告',
  'Review Type': '评论类型',
  'Review Type:': '评论类型：',
  Reviewer: '发帖人',
  Reviewers: '发帖人数',
  Reviews: '评论',
  'Reviews Positive%': '评论正面占比',
  'Reviews Rating': '商店评分',
  'Reviews Type: Posts': '评论类型：主贴',
  'Reviews Type: Posts & Comments': '评论类型：主贴和评论',
  'Reviews are sourced from the DataBrain crawler': '评论来自DataBrain爬虫',
  'Reviews are sourced from the DataBrain crawler and statistically analyzed by language detection':
    '评论来自DataBrain爬虫，通过语种识别统计',
  'Reviews by Language': '分语种评论统计',
  'Reviews in Chinese': '中文评论',
  'Reviews in Chinese(Total items: {total})': '中文评论（共 {total} 条）',
  'Reviews in English': '英文评论',
  'Reviews in English(Total items: {total})': '英文评论（共 {total} 条）',
  'Reviews in Original Language': '原文评论',
  'Reviews in Original Language(Total items: {total})': '原文评论（共 {total} 条）',
  'Reviews-1': '条评论',
  'Reviews-2': '评论量',
  'Reviews-3': '内容详情',
  'Reviews-4': '评论数',
  'Reviews-4%': '评论%',
  Rising: '激增',
  'Rising Events': '激增事件',
  'Rising Event：Events with an increase of 80% or more in comments compared to the previous day':
    '激增事件：较上一天评论数激增80%以及以上的事件',
  'Rising Keywords': '突增关键字',
  'Rising Keywords-1': '当日突增关键词',
  'Rising Topics': '突增话题',
  'Risk Type': '风险类型',
  'Rules for Main Change Topics: In the left topic line chart, calculate the change rate of the start date and end date of all topics under the current indicator, and take the top three topics as the main change topics. If the date is set to one day, one week, or one month, the change rate between the date and the previous day, one week, or one month is calculated.':
    '主要变动话题取值规则：在左侧话题折线图中，计算当前指标下所有话题的起始日期与结束日期的变化率，取前三话题作为主要变动话题。其中单日/单周/单月，分别与前1天/前1周/前1个月的变化率进行计算。',
  SDLW: '上周同期',
  'SEA Hero Summary': '全球英雄总结',
  SHLD: '昨日同期',
  SMLY: '上年同期',
  SWLM: '上月同期',
  'Same Day Last Week': '上周同期',
  'Same Start Date (Including Align to Release)': '相同起始时间(支持对齐上线时间)',
  Saturday: '星期六',
  Save: '保存',
  'Save Current': '保存当前内容',
  'Save Filter Setting': '保存筛选方案',
  'Save Report': '保存报表',
  'Save Report-1': '保存报告',
  'Save to "Summary List"': '保存到【总结列表】',
  'Save to Analysis List': '保存至报告列表',
  'Save to Analysis list and view later': '保存至报告列表，稍后查看',
  'Save to Summary list and view later': '保存到任务列表，稍后再看',
  'Save to System': '保存到系统',
  'Save to {page}': '保存到{page}',
  'Saved Analysis List': '已保存报告列表',
  'Saved Prompts': '保存Prompts',
  'Saved failed': '保存失败',
  'Saved setting can be used in all filters in Opinions': '保存的筛选方案仅支持在舆情系统使用',
  'Saved settings can only be used in the filters on this page.': '保存的筛选方案仅适用于本页的筛选器。',
  'Saved successfully': '保存成功',
  'Scatter chart': '散点分布图',
  'Score Change': '对比评分变化',
  'Score Change%': '对比评分变化率',
  'Score Filter': '筛选评分',
  'Score Trends': '评分趋势',
  'Score Value': '商店评分',
  'Scraping failed': '爬取失败',
  'Scraping failed, the historical data will be displayed by default': '最新爬取任务失效，默认展示历史数据',
  Search: '搜索',
  'Search AI Tags': '搜索AI标签',
  'Search Analysis Name': '搜索报告名称',
  'Search Analysis Name or Creator': '搜索分析报告名称或创建人',
  'Search Any Game in the table': '搜索下方表格中的游戏',
  'Search Creative title or body': '搜索素材标题或文案',
  'Search Hashtag': '搜索Hashtag',
  'Search Influencer name.': '搜索网红名称。',
  'Search Memes': '搜索热梗',
  'Search Recommendation': '相关推荐',
  'Search Result': '搜索结果',
  'Search Trends': '搜索热点',
  'Search any game': '搜索游戏',
  'Search any game in the following table': '搜索列表中的游戏',
  'Search any game in the following table.': '搜索列表中的游戏',
  'Search any metric in the table': '搜索下表的指标',
  'Search by crawler': '搜索爬虫',
  'Search by keywords or phrases.': '输入关键字或词组进行搜索',
  'Search by metrics': '搜索指标',
  'Search by source': '搜索数据源',
  'Search for keywords from the user preconfigured keywords table': '从用户预配置的码表中搜索关键字',
  'Search for keywords from the user preconfigured keywords table and the NLP keywords library':
    '从用户预配置的关键字码表和NLP海量词库中搜索关键字',
  'Search for more keywords': '搜索获取更多关键字',
  'Search for reviews': '搜索评论',
  'Search for reviews by keywords or phrase': '通过关键字或词组搜索内容',
  'Search for reviews by keywords or phrases.': '输入关键字或词组搜索评论。',
  'Search hashtag': '搜索Hashtag',
  'Search index(Last Day)': '搜索指数（昨日）',
  'Search index(Today)': '搜索指数（今日）',
  'Search influencer name': '搜索网红名称',
  'Search news headline by original keyword or phrase': '通过源语种关键字或词组搜索新闻标题',
  'Search news headlines by keyword or phrase': '通过关键字或词组搜索新闻标题',
  'Search pages': '搜索页面',
  'Search reviews with these keyword combinations (examples)': '将使用这些关键词组合搜索评论 (示例)',
  'Search reviews with these keyword combinations.': '将使用这些关键字组合搜索评论',
  'Search streamer/title/URL': '搜索主播名/标题/URL',
  'Search video': '搜索视频',
  'Search video name': '搜索视频标题',
  Searches: '搜索',
  Season: '篇章',
  'Second Correlation Words': '二级相关词',
  Security: 'Security',
  'Security Channel': '安全频道',
  'Security Mentions': '舆情安全声量',
  'Security Weekly Report': '安全周报',
  'Security-Related Mentions': '舆情安全声量',
  'Security-Related Mentions Weekly Report': '舆情安全周报',
  'Segmentation & Tags': '分层及标签',
  'Segmentation Distribution': '网红分层标签分布',
  'Select All': '全选',
  'Select Top 20 items': '选中前20项',
  'Select from system-recommended keywords, including translations and synonyms, for quick results.':
    '请选择系统推荐的关键字，这些关键字包含翻译及其同义词，以便快速获取所需结果。',
  Selected: '已选',
  'Selected AVG. Rating': '所选时段平均评分',
  'Selected AVG. Rating & Reviews': '所选时段平均评分及评论数',
  'Selected AVG. Rating (T-2)': '所选时段平均评分 (T-2)',
  "Selected AVG. Rating displays yesterday's Rating by default and Lifetime Accum.Rating displays today's rating.":
    '苹果商店评论滞后1天，所选时段平均评分默认显示昨日数值，历史累积评分可显示今日实时数值',
  'Selected Filters': '已选中筛选器',
  'Selected Keywords': '已选关键字',
  'Selected Positive%': '正面评论占比',
  'Selected Recommended%': '所选时段推荐百分比',
  'Selected Reviews': '所选时段平均评分',
  'Selected Reviews-1': '所选时段评论',
  'Selected User Score': '所选时段平均评分',
  'Selected Users': '指定人员',
  'Selected users can view this report in AI Task Center': '可在AI报告中心查看该报告',
  'Selected:': '已选中:',
  'Selected: {language} - {comment}': '已选中：【{language}】- 【{comment}】',
  'Selling Points': '亮点',
  'Sending Mailbox': '发送邮箱',
  'Sensor Tower DAU': 'Sensor Tower 日活',
  'Sensor Tower Download': 'Sensor Tower 下载',
  'Sensor Tower MAU': 'Sensor Tower 月活',
  'Sensor Tower Revenue': 'Sensor Tower 收入',
  'Sensor Tower WAU': 'Sensor Tower 周活',
  Sentiment: '情感分',
  'Sentiment & DAU REV DLS': '情感分 & 日活 收入 下载',
  'Sentiment & MAU REV DLS': '情感分 & 月活 收入 下载',
  'Sentiment & PCCV DigitalREV': '情感分 & 直播观众峰值 线上收入',
  'Sentiment & PCU DigitalREV Units': '情感分 & 最高在线玩家 线上收入 销量',
  'Sentiment & WAU REV DLS': '情感分 & 周活 收入 下载',
  'Sentiment AVG': '平均情感分',
  'Sentiment Category': '情感分类',
  'Sentiment Criteria': '情感分标准',
  'Sentiment Distribution': '情感分布',
  'Sentiment Editing': '编辑情感分',
  'Sentiment Score': '情感分',
  'Sentiment Sentences': '情感分拆句',
  'Sentiment Settings': '情感分维度',
  'Sentiment decrease': '情感分下降',
  'Sentiment increase': '情感分上升',
  'Sentiment: Change%': '情感分变化率',
  'Sentiment: Sentiment score is to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, with a scale of 1-5. 5 is Positive, 3 is Neutral, 1 is Negative.':
    '情感分：情感分是通过NLP算法和情感分析来对每条评论的情感倾向进行打分，分值范围为1-5。5 代表  Positive 正面的，3 代表 Neutral 是中性的，1 代表 Negative 负面的。',
  'Sentiment: Sentiment score is used to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, on a scale of 1-5. Sentiment score greater than 3.5 is positive, score lower than 2.5 is negative, and score between 2.5-3.5 is neutral.':
    '情感分：情感分是通过NLP算法和情感分析来对每条评论的情感倾向进行打分，分值范围为1-5。情感分大于3.5为正面，小于2.5为负面，在2.5到3.5之间为中性。',
  'Sentiment Editing': '编辑情感分',
  'Separate Multiple Reviewers With ",".': '用","分隔多个发帖人',
  'Separate Multiple Steam ID With ",".': '用","分隔多个Steam ID',
  'Separate by Channel': '按渠道拆分',
  'Separate by Country': '按国家拆分',
  'Separate by Language': '按语种拆分',
  'Separate by Reviews Rating': '按星级拆分',
  'Separate by Sentiment': '按情感分拆分',
  'Separate by Time': '按时间拆分',
  'Separate keywords using ( , )( ; )( 、) ( | ), or line breaks':
    '关键词之间使用 ( , ) ( ; ) ( 、) ( | ) ( 换行 ) 分割',
  September: '九月',
  'Server Weekly': '服务器周报',
  Sessions: '直播场次',
  'Set Comparison Time (Up to 4 games can be compared)': '设置对比时间（最多对比4款游戏）',
  'Set competitors on the left side of the table, and check the comparison of opinion metrics and trends.':
    '表格左侧设置竞品，查看舆情汇总指标对比和趋势对比。',
  'Set display events': '事件展示',
  'Set tagging time range and filter conditions': '确定打标时间范围和筛选条件',
  'Set the countries you are most concerned about and they will be displayed by default.':
    '设置最关注的国家，支持默认展示。',
  'Set the countries you want to focus on, and they will be displayed in the table by default, and this change takes effect for you only.':
    '设置需关注的国家，这些国家将默认展示在下方表格，修改仅针对本用户生效。',
  Setting: '设置',
  'Setting Name': '方案名词',
  Share: '分享',
  'Share Report': '分享报告',
  'Share of Security Mentions': '舆情安全声量占比',
  'Share of Security Mentions (Security Mentions / Total Game Mentions)': '舆情安全声量占比（舆情安全声量/游戏总声量）',
  'Share-1': '占比',
  'Share-2': '分享量',
  'Shared With Me': '与我共享的报告',
  Shares: '分享量',
  'Shares Change%': '分享量环比',
  'Shift down': '下移',
  'Shift up': '上移',
  Show: '展开',
  'Show All': '展开',
  'Show All Comments of This Post': '展示本贴所有评论',
  'Show Anomaly Attribution': '展示异动归因',
  'Show Change%': '展示指标值加环比',
  'Show Channel': '展示渠道',
  'Show Country': '展示国家/地区',
  'Show DoD': '展示环比',
  'Show Events': '显示事件',
  'Show Keyword & Topic': '展示词云图&话题分布',
  'Show Language': '展示语种',
  'Show Less': '收起',
  'Show Metrics': '指标展示',
  'Show More': '展示更多',
  'Show Region': '展示区域',
  'Show Representative Reviews': '显示观点代表性评论',
  'Show Tagged Videos Only': '仅展示包含标签的视频',
  'Show all tag': '展开全部标签',
  'Show comparison chart of column data. Comparison chart calculation method: Based on the maximum value of the column where the value resides,  use a bar chart to show the proportion of the value to the maximum value.':
    '展示列数据对比图示。对比方法：取当前列最大值作为参考，获得当指标占本列最大值的比例。',
  'Show event axis': '显示事件坐标轴',
  'Show event bubbles': '显示事件气泡',
  'Show graph': '展开图表',
  'Show on page': '在页面上显示',
  'Show ranking among competitors': '显示竞品及排名',
  'Show top {number} mentions topics only': '仅展示声量排行前 {number} 的话题',
  'ShowChange%-1': '展示环比',
  'Similar Games': '其他竞品',
  'Simplified Chinese': '简体中文',
  'Social Media': '社交媒体',
  'Social Media Comments': '社媒评论',
  'Social Media Metrics Details': '社媒指标详情',
  Sorry: '提示',
  'Sorry, the export limit is set to {value} rows.': '对不起，最大只能下载{value}条',
  'Sort By': '排序',
  'Sort all influencers (time-consuming)': '针对所有网红排序（耗时较长）',
  'Sort by': '排序：',
  'Sort by Mentions': '按声量排序',
  'Sort by Mentions DoD': '按声量环比排序',
  'Sort by Relevance': '按相关性排序',
  'Sort by Sentiment': '按情感排序',
  'Sort by Sentiment DoD': '按情感环比排序',
  'Sort by {name}': '按{name}排序',
  'Sort by {name} Change%': '按{name}变化率排序',
  'Sort influencers with more than 5K followers (faster)': '针对粉丝量超过5K的网红排序（更省时）',
  Source: '来源',
  'Source Feature': '数据源特点',
  'Source URL': '数据源官网',
  'Southeast Asia': '东南亚',
  'Specific Categories': '指定分类报告',
  'Spotlight Reports': '专题报告',
  Spreading: '扩散中',
  'Spreading – Attention Required': '扩散中,关注',
  Stable: '稳定',
  'Stable – Monitor Only': '稳定/噪音,观察即可',
  'Stacked Table': '堆图表格',
  'Stacked chart': '堆积图',
  'Starred Positive Reviews': '星标好评数',
  'Starred Reviews': '星标评论数',
  'Starred Tag': '星标',
  'Start Time': '开始时间',
  'Start immediately': '任务即刻触发',
  'Start&End Date': '开始至结束日期',
  Statistics: '统计',
  'Statistics are only collected on the content (Videos and posts) published by Influencer on this game, excluding content not related to the game.':
    '仅根据 Influencer 针对本游戏的发布内容（视频和图文帖）进行统计，不包括非本游戏相关内容。',
  Stats: '统计',
  'Stats based on Top 500 Video by views': '数据基于Top 500新增视频统计',
  Status: '状态',
  'Stay on top of the latest trends across the global web, alerting users to potential risks and safeguarding game reputation.':
    '及时通晓海外全网态势，预警风险保障游戏口碑',
  'Steam Added Reviews': 'Steam新增评论',
  'Steam Analysis': 'Steam分析',
  'Steam Filtered Reviews': '已选Steam评论',
  'Steam ID': 'Steam ID',
  'Steam PCU': 'Steam PCU',
  'Steam Performance': 'Steam 指数',
  'Steam Performance-1': 'Steam商店',
  'Steam Players': 'Steam 玩家',
  'Steam Positive Rate': 'Steam好评率',
  'Steam Purchase': 'Steam购买',
  'Steam Ratings': 'Steam 商店评分',
  'Steam Related': 'Steam 相关',
  'Steam Revenue': 'Steam 收入',
  'Steam Review Positive%': 'Steam评论正面占比',
  'Steam Reviews': 'Steam 评论',
  'Steam Reviews Summary': 'Steam 评论总结',
  'Steam Selected Reviews Positive%: Based on all Steam reviews crawled during the selected time period, and the proportion of positive reviews is calculated.':
    'Steam正面评论百分比：基于所选时段爬取到的Steam全部评论，经过计算得出正面评论占比值。',
  Stop: '停止生成',
  'Stop Analysis?': '停止分析报告？',
  'Stop Repeat Task?': '停止例行任务？',
  'Stop failed': '停止操作失败',
  'Stop success': '已停止',
  'Stop {name}? This action will delete the analysis and is irreversible. Please proceed with caution.':
    '需要停止 {name}？停止后报告将删除，且不可恢复，请谨慎操作。',
  'Stop {name}? This subscription will be canceled and cannot be undone. Please proceed with caution.':
    '需要停止 {name}? 停止后不再进行例行分析，请谨慎操作。',
  'Stop-1': '停止',
  Stopped: '停止',
  'Store Score': '商店评分',
  Stream: '直播',
  'Stream Sessions': '直播场次',
  'Stream Start Time': '直播开始时间',
  'Stream Time': '直播时间',
  'Stream Titles': '直播标题',
  Streamer: '主播',
  'Streamer Sentiment': '主播情感分',
  'Streamer Type': '主播类型',
  "Streamer's Ongoing Topic": '主播讨论话题',
  Streamers: '主播',
  Streaming: '直播',
  'Streaming Influencers': '直播类网红',
  'Streaming Status': '直播状态',
  Sub: '子',
  'Sub Sentiment': '情感分拆句',
  'Subcore: Competitor-Related': '次核心：竞品相关',
  Subscribe: '订阅',
  Subscribed: '已订阅',
  Subscriber: '订阅人',
  'Subscription failure': '订阅失败',
  'Subscription successful.': '订阅成功',
  'Subscription time': '订阅时间',
  Subscriptions: '例行任务',
  'Subscriptions({totalSubscriptions})': '例行任务({totalSubscriptions})',
  'Subsequent updates will be triggered at the top of each hour.': '后续更新将在每小时整点触发',
  'Subsequent updates will be triggered daily at 00:00 (UTC+8).': '后续更新将在每天的00:00 (UTC+8)触发',
  'Subsequent updates will be triggered every 7 days at 00:00 (UTC+8).': '后续更新将在每7天的 00:00 (UTC+8)触发',
  Subtopic: '子话题',
  'Subtopic Escalation': '子话题发酵四象限',
  'Successfully Unsubscribed from AI Summary Emails': '成功取消订阅AI总结邮件',
  'Successfully Unsubscribed from AI Summary WeCom Notification': '成功取消订阅AI总结企业微信推送',
  'Successfully crawled {count} comments.': '成功爬取 {count} 条评论',
  'Successfully saved analysis': '保存成功',
  Sum: '总和',
  'Sum (Keyword mentioned frequency)': '总计 (关键字提及次数)',
  'Sum (Removed duplicate reviews)': '总和 (评论已去重)',
  'Sum (Topic mentioned frequency)': '总计 (话题提及次数)',
  'Sum Airtime': '总计直播时长',
  'Sum Engagement': '互动总量',
  'Sum Hours Watched': '总计观看时长',
  'Sum Influencers': '网红汇总',
  'Sum Volume': '新闻总量',
  'Sum of Rating': '总评分数',
  'Sum of Reviews': '评论总和',
  'Sum of Reviews-1': '总评论数',
  Summary: '摘要',
  'Summary API is currently unstable, please try again': '智能总结接口不稳定，请重试',
  'Summary Data Range': '数据总结时间',
  'Summary Detail': '总结详情',
  'Summary End Time': '总结结束时间',
  'Summary List': '总结列表',
  'Summary Mode': '总结模型',
  'Summary Name': '总结报告标题',
  'Summary Name CN': '总结报告标题(中文)',
  'Summary Name EN': '总结报告标题(英文)',
  'Summary Options': '总结类型',
  'Summary Ranking of Selected Channels': '所选渠道汇总排名',
  'Summary Start Time': '总结开始时间',
  'Summary by 5-minutes intervals': '每5分钟总结',
  'Summary failed': '总结失败',
  Sunday: '星期日',
  'Support Language': '已支持语种',
  'Switched to the latest date with data': '已为你切换到最新有数据的日期',
  'Syntax examples': '语法示例',
  'System Recommendations': '系统推荐',
  Table: '表格',
  Tag: '标签',
  'Tag Analysis': '标签分析',
  'Tag filtered data with topics': '对筛选数据进行话题打标',
  'Tagging failed': '标注失败',
  Tags: '标签',
  'Tags Analysis': '标签分析',
  'Take the top 10 influencers with the number of followers on the whole channel. Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.':
    '取全平台的粉丝量排名前 10 的网红，将他们的粉丝量求平均值。各平台的粉丝量取值：Reddit 取自 Members，Youtube 取自 Subscribe，其他平台取自 Followers。',
  'Tap Tap': 'Tap Tap',
  'Task delivery failed.': '任务投递失败。',
  'Task generation failed, possibly due to the following reasons:': '任务创建失败，可能由于以下原因导致：',
  'Tencent Games': '腾讯游戏',
  Text: '文本',
  'Text Posts': '文本帖文',
  'The AI API is unstable, Please {btn}': 'AI 接口不稳定，请点击 {btn}',
  'The AI summary is being generated and is expected to take 1 to 3 hours, depending on the content.':
    'AI生成中，预计将等待1~3小时，具体时间根据内容而定。',
  'The AI summary report you have requested for the current game will be displayed on this page. (Excluding keyword and URL analysis)':
    '本页将展示您在当前游戏申请的AI总结报告。（不含关键字及URL分析）',
  'The AI summary task is in the queue, and the report content has not been generated yet.':
    'AI排队中，暂未生成报告内容',
  'The AI tags are supported by the Data & AI team. For more information, please contact zhenquanlin@tencent.com.':
    'AI标签由Data&AI团队提供技术支持，可联系zhenquanlin@tencent.com了解更多',
  'The Game Group has configured permission control for this page. ': '业务对该页面配置了权限管控',
  'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.':
    '核心指标页面呈现舆情关键指标表现，舆情总声量和情感，并支持同时对比DAU和收入趋势。',
  'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions.':
    '核心指标页面呈现舆情关键指标表现，舆情总声量和情感。',
  'The Launch Day 1': '上线1天',
  'The Launch Day 30': '上线30天',
  'The Launch Day 7': '上线7天',
  'The Lifetime Accumulative Reviews of Google Play does not distinguish between countries. The table only shows the number of reviews under the corresponding edition of countries.':
    '累积评论数未区分国家，表格仅展示国家对应版本下的评论数。',
  'The Performance page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.':
    '指数页面呈现舆情关键指标表现，舆情总声量和情感，可对比日活和收入趋势。',
  'The Performance page presents the performance of key metrics, the total mentions and sentiment of the opinions.':
    '指数页面呈现舆情关键指标表现，舆情总声量和情感。',
  'The Summary page presents the clustered hot content based on the NLP algorithm. Click the events on the left to view the detailed reviews on the right.':
    'Summary页面呈现基于NLP算法的聚类热点内容，点击左侧事件可在右侧查看详细评论。',
  'The analysis is currently being generated. If you feel the task planning is inaccurate, you can pause at any time.':
    '正在生成分析报告。如任务规划与预期不符，可随时暂停调整。',
  'The analysis will take 15 to 30 minutes to generate.': '生成报告预计用时15~30分钟。',
  'The countries displayed in Google Play reviews are obtained by crawling through the Google Play scores for each language and then mapping the language to the country.\nClick to see the National Language Mapping rule >':
    'Google Play 评论中显示的国家，是通过爬取 Google Play 各语种评分后，再通过语种映射到国家而获得。\n点击查看国家语种映射对照表 >',
  'The current algorithm does not support event tracking. Please stay tuned for future updates.':
    '当前算法暂不支持事件追踪，敬请期待',
  'The current calculation time zone is UTC+8 time zone.': '当前计算时区为UTC+8时区。',
  'The current game has low priority, and the original text is unavailable in Chinese translation. For any inquiries, please contact {email}.':
    '当前游戏优先级较低，原文暂不支持中文翻译，如有疑问请联系{email}。',
  'The current position of this review': '当前所处位置',
  'The data from each channel is currently updated hourly': '各渠道数据当前为小时级更新',
  'The data has been mostly imported, and the change rate is relatively reliable.':
    '数据基本入库完毕，同环比数据较为可靠',
  "The data is taken from Metacritic's official User Score data.": '数据取自 Metacritic 官方的 User Score 数据。',
  'The data of the selected date is insufficient, and no valid event is obtained.':
    '所选日期数据量不足，未获得有效事件。',
  'The following content is provided by GPT and is for reference only': '以下总结内容由GPT提供，仅供参考',
  'The following keywords are clustered from news headlines and are not related to the main content of the news articles.':
    '关键字仅通过新闻标题归类。',
  'The following reviews are sorted by engagements': '以下评论按互动量排序',
  'The following topics are clustered from news headlines and are not related to the main content of the news articles.':
    '话题仅通过新闻标题归类。',
  'The frequency indicates the individual occurrence frequency of a keyword.\nFor example, in the sentence “love love love this game”, the word frequency of “Love” is 3.':
    '词频表示关键字单独出现的频率。\n例如，1个句子中出现“love love love this game”，“Love” 词频为3。',
  'The game《{gameName}》has not been visited for a while, so data updates have been stopped to save resources. If you need to view the latest data, please contact {email} or submit your requirements in the "{feedback}" section at the top right of the navigation bar.':
    '游戏《{gameName}》有一段时间没有被访问，因此已停止数据更新以节省资源。 如果您需要查看最新数据，请联系{email}或在导航栏右上角的“{feedback}”部分提交您的需求。',
  'The hottest content based on NLP algorithm clustering': '基于NLP算法聚类得出讨论最多的事件内容',
  'The hour watched duration: the total duration from the time when users enter the live room to the time they leave.':
    '直播观看时长：从用户进入直播间开始到离开直播间的总时长。',
  'The initial report includes a opinion summary. Subsequent updates will only refresh the topic tagging results. Please navigate to the Report Page to generate the summary on need.':
    '首份报告包含舆情总结，后续更新仅更新话题打标结果，请前往报告页按需触发舆情总结。',
  'The input data cannot exceed 100%': '输入数据不能大于100%',
  'The keyword data statistics in this place adopt the original keyword list, which has not undergone the subsequent synthetic keyword processing, namely, it does not integrate synonymous keywords.':
    '此处关键字数据统计使用的原始关键字表，未经过后期的合成关键字处理，即不会合并同义关键字。',
  'The large model selects valid reviews to summarize opinions, which may not cover all reviews.':
    '大模型选取有效评论进行观点总结，可能不覆盖所有评论。',
  'The memes are distilled by AI. Please use them as a reasonable reference. If you have any issues, please contact fduhuixinli@tencent.com.':
    '当前热梗为AI提炼，请合理参考，如有问题请联系 fduhuixinli@tencent.com',
  'The mentions of the game are related to the monitoring configuration': '游戏舆情声量大小与监控配置相关',
  'The minimum value must be {num}.': '最小必须为{num}',
  'The module for Partnered Streaming Influencers is not yet developed. Please Stay tuned for updates.':
    '直播网红的合作模块暂未开发，敬请期待',
  'The most discussed topic content based on the reviews labeled by topic classification':
    '基于命中话题的评论得出讨论最多的话题内容 ',
  'The network is unstable. Failed to load filters. Please try again.': '网络不稳定，无法提交筛选条件，请重试',
  'The number of reports': '举报条数',
  'The options provided by this filter are all lists of Steam ID within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load.':
    '本筛选器提供的选项均为所选时间段内的Steam ID列表。当所选时间段较长时，您可能需要等待较长的时间。',
  'The options provided by this filter are all lists of reviewers within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load.':
    '本筛选器提供的选项均为所选时间段内的发布人列表。当所选时间段较长时，您可能需要等待较长的时间。',
  'The page has been successfully added to the Favorite Page.': '成功收藏该页面',
  'The page you are trying to access cannot be found. Please check the page link.':
    '无法找到您所访问的页面，请确认页面链接。',
  "The percentage of positive reviews taken from Steam's official calculation.":
    '数据取自Steam官方计算的正面评论占比数。',
  'The previous corresponding period': '环比上一周期',
  'The real-time data of the current day is displayed by default. If there is no data, please change the date filter to another date':
    '默认展示当天实时数据，如无数据，请更改日期筛选到其他日期查看',
  'The report generation has been manually stopped by the user.': '用户手动停止报告。',
  'The report has been manually stopped.': '已手动停止报告',
  'The report task has been created and saved to the AI Task Center. By default, it is visible only to you; you can adjust this by clicking on the {permission} settings.':
    '已创建报告任务并保存至“AI 任务中心”，默认仅自己可见，如需调整可点击修改{permission}。',
  'The report task has been created. By default, it is visible only to you; you can adjust this by clicking on the {permission} settings.':
    '已创建报告任务。默认仅自己可见，如需调整可点击{permission}',
  'The report will be displayed on the AI Insights Report page': '报告将展示在AI洞察报告页',
  'The report will be sent to this email automatically upon generation': '报告生成后将自动发送报告至该邮箱',
  'The score for the selected period has not been crawled yet.': '暂未爬取所选时段的评分。',
  'The selected tier1 topic will be displayed in the left-hand shortcut positioning area. \n\nThe selected tier2 topic will be displayed in the topic chart below, while any unselected tier2 topics under the tier1 topic will be hidden.':
    '选中的一级话题将展示在左侧快捷定位区。\n\n选中的二级话题将在下方话题图表中显示，同时隐藏所属一级话题下未选中的其他二级话题。',
  'The sentiment score and translation of reviews can be modified, and the modification will take effect the next day.':
    '情感分和评论翻译可被编辑修改，按天生效。',
  'The sentiment score of each keyword was obtained by averaging the sentiment score of all comments corresponding to each keyword.\nKeywords with sentiment score less than 2.5 show red; between 2.5 to 3.5 show gray; greater than 3.5 show green.':
    '通过对每个关键字对应的所有评论的情感分求平均，获得关键字的情感分。\n其中关键字情感分小于 2.5 分的显示红色；处于 2.5 至 3.5 之间的显示灰色；大于 3.5 的显示绿色',
  'The sentiment score, channel, country, and language data of the news page have been updated since 2022-09-02. The keyword and topic data have been updated since 2023-05-30.':
    '新闻页的情感分、渠道、国家/地区、语种数据从2022-09-02开始更新。关键字和话题数据从2023-05-30开始更新。',
  'The server is currently busy or the resource is temporarily unavailable. Please try again later.':
    '当前服务器繁忙或资源暂时不可用，请稍后再试',
  "The system doesn't recognize the format of the link you entered. Please verify the link and try again.":
    '系统无法识别您输入的链接格式，请检查链接是否正确。',
  'The system will refresh automatically every 30 minutes until the live stream ends':
    '直播结束前系统将每30分钟自动刷新',
  'The update only refreshes the topic tagging results; please go to the report page to trigger the sentiment summary as needed.':
    '更新仅更新话题打标结果，请前往报告页按需触发舆情总结。',
  'The value of Min Correlation must be more than {min} and less than {max}.': '请输入大于{min}且小于等于{max}的数字。',
  'The versions are different, so dragging and dropping is not possible.': '版本不一致，无法拖拽',
  'There are no AI analysis tasks at the moment.': '当前暂无 AI 分析任务',
  'There are no events scheduled for this period.': '该时段没有事件。',
  'There are no following games.': '暂未收藏游戏',
  'There are no weekly reports at the moment.': '当前没有周报数据',
  'There is a delay in data updating, so the data on this page (such as views, interactions, likes, shares, comments, followers, etc.) are not realtime data.\nUpdate frequency:\nPosts from Monitor accounts will be updated once a day for up to 7 days.\nAmong posts from keyword sources, only posts on Youtube, Twitch and Tiktok channels are updated once a day, up to 7 days; Posts from other sources have no updates.':
    '数据更新存在延时，所以本页数据（例如观看、互动量、点赞、分享、评论、关注等）非实时数据。\n更新频率：\n官号来源的帖子每天将更新1次，最多更新7天。\n关键字来源的帖子中，仅 Youtube、Twitch、Tiktok 渠道的帖子每天更新1次，最多更新7天；其他来源帖子无数据更新。',
  'There is not enough data under the current filter to generate Hot Event.':
    '当前条件下的数据量较少，不足以生成热门事件。',
  "There's no data under the current search conditions": '当前搜索条件下无数据',
  'Third Party': '三方号',
  'This Hour': '当前时间',
  'This Month': '本月',
  'This Week': '本周',
  'This Week-1': '本周数据',
  'This analysis report has been saved to the {page}': '此分析报告已保存至{page}',
  'This analysis report has been saved.': '已保存至报告列表',
  'This comment has no post.': '本评论没有主贴。',
  "This date hasn't been tagged with AI Topics yet. Please pick one from the available tagged dates.":
    '所选日期尚未完成AI话题打标，请在已打标范围内重新选择。',
  'This game has been released for less than 30 days and currently does not have Recent Reviews Rating on Steam.':
    '该游戏上线时间不足30天，Steam暂无最近评分。',
  'This game is not configured with NLP tasks, feel free to contact {contact} if you need.':
    '当前游戏未配置例行NLP任务，如有疑问请联系{contact}。',
  'This game is not yet configured in the Opinions system. You can contact {email} to add this game.':
    '舆情系统暂未配置该游戏数据。如需配置游戏，请联系 {email}。',
  'This link does not contain a Shortid, so the filter options cannot be displayed.':
    '本链接无Shortid，无法展示筛选项。',
  'This page supports a maximum date range of 90 days. For longer-term game rankings, please visit {btn}.':
    '本页面仅支持最长90天的数据查询。如需查看更长时间范围的游戏指标排名，请使用{btn}。',
  'This page uses PMI (Pointwise Mutual Information) to measure the relevance of keywords.\nPMI is the ratio of the probability of two keywords co-occurring in the text to the product of their individual probabilities, and then taking the logarithm. It means that if two keywords x and y are independent, that is, unrelated, then their joint probability is equal to the product of their individual probabilities, and the PMI formula calculates a relevance result of zero.\nThe larger the PMI value, the more relevant the two keywords are, and the smaller the PMI value, the less relevant they are.':
    '本页使用PMI (点互信息)来衡量关键字的相关性。\nPMI为两个关键字在文本中共同出现的概率与它们单独出现的概率之比，然后取对数。其表达的含义是如果两个事件x和y是独立的，即不相关的，那么它们同时发生的概率就等于它们各自发生的概率的乘积，此时PMI公式计算出相关性为0。\nPMI值越大，说明两个关键字之间越相关，越小说明越不相关。',
  'This post has no URL': '该主贴无URL',
  'This process will take 1 to 3 minutes, depending on the submitted content.':
    'GPT 生成摘要将需要 1 到 3 分钟，具体取决于提交的内容量。',
  'This report will be saved to the {page} under the [AI Analysis Hub] menu.':
    '本报告将保存到【AI分析中心】菜单下的 {page} ',
  "This review don't have URL": '本评论暂无链接',
  'This review has no url': '该评论没有url',
  'This time period': '当前时间段',
  'This video cannot obtain subtitle content': '当前视频无法获得字幕内容',
  'This video has no subtitles': '当前视频暂无字幕',
  Thursday: '星期四',
  'Tier 1 Category': '一级分类',
  'Tier 1 Tags': '一级标签',
  'Tier 1 Topic': '一级话题',
  'Tier 1 Topic Breakdown': '常用的一级话题',
  'Tier 2 Category': '二级分类',
  'Tier 2 Tags': '二级标签',
  'Tier 2 Topic': '二级话题',
  'Tier 2 Topic Performance': '二级话题表现',
  'Tier1Topic-1': '所属一级话题',
  'TikTok Videos': 'TikTok视频量',
  'TikTok Views': 'TikTok观看量',
  'TikTok platform has not provided relevant data for the selected date, {button}.':
    '当前日期下Tiktok平台暂未提供相关数据，{button}。',
  'TikTok shorts': 'TikTok短视频',
  Time: '时间',
  'Time (UTC+8)': '时间 (UTC+8)',
  'Time Interval': '时间区间',
  'Time Range': '时间范围',
  'Time Settings': '时间维度',
  'Time(UTC+8:00)': '发布时间',
  'Time-1': '按时间',
  'Timeline of Mentions': '声量趋势图',
  'Timeline of Mentions & Sentiment': '声量&情感分趋势图',
  'Timeline of Sentiment': '情感趋势图',
  'Timeline of Top 10 Mentions': '前10关键字声量趋势',
  'Timeline of Top 15 Topics': '前15话题趋势',
  Title: '标题',
  'To avoid impacting system performance, Exact Search only supports batch queries of up to 200 keywords.':
    '为避免影响系统性能，精准搜索只支持批量查询200组关键字。',
  'To avoid impacting system performance, Extended Search does not support + combination queries.':
    '为避免影响系统性能，拓展搜索不支持+组合查询。',
  'To avoid impacting system performance, Extended Search only supports batch queries of up to 20 keywords.':
    '为避免影响系统性能，拓展搜索仅支持批量查询20个关键字。',
  'To be updated': '待更新',
  'To enhance search efficiency, the list only displays the top 100 keywords.':
    '为提高搜索效率，列表仅展示前100关键字。',
  'To improve search efficiency, select up to 10 keywords': '为提升搜索效率，最多可选10个关键字',
  Today: '今天',
  'Top 1 Account': '排行第1',
  'Top 10 Mentions': '前10关键字声量',
  'Top 10 Searches': '前 10 搜索量对比',
  'Top 15 Topics': '前15话题',
  'Top 15 Topics Ranked by ': '排行前15话题',
  'Top 2 Account': '排行第2',
  'Top 3 Account': '排行第3',
  'Top 3 Reviews': '内容排名前 3 ',
  'Top 30 Categories': '品类前30',
  'Top 50 Hashtags': '排行前50的Hashtag',
  'Top 50 Publications': '排行前50的帖子',
  'Top 500 New Video Likes': 'Top 500 新增视频点赞量',
  'Top 500 New Video Views': 'Top 500 新增视频观看量',
  'Top Critic Average': 'Critic平均值',
  'Top Posts by': '帖子排序',
  "Top contributors to this week's fluctuation: {A};": '本周波动贡献率TOP为{A}；',
  'Top10 Streamings': 'Top10 直播动态',
  'Top10 Videos': 'Top10 视频动态',
  Topic: '话题',
  'Topic & Keyword': '话题 & 关键字',
  'Topic / Keywords': '话题/关键字',
  'Topic Analysis': '话题分析',
  'Topic Breakdown': '话题下钻 ',
  'Topic Definition': '话题定义',
  'Topic Editing': '编辑话题',
  'Topic Keywords': '话题关键字',
  'Topic Name': '话题名称',
  'Topic Performance': '话题表现',
  'Topic Sentiment': '话题情感分',
  'Topic Summary': '正负面话题排行',
  'Topic Summary-1': '话题总结报告',
  'Topic Tagging Model': '话题打标模型',
  'Topic Tagging:': '话题标注：',
  'Topic Tracking': '话题追踪',
  'Topic Trend': '话题趋势报告',
  'Topic Trends': '话题趋势',
  'Topic mentioned frequency': '话题提及次数',
  Topics: '话题',
  'Topics are pre-configured and can be applied to topic classification of reviews through keyword matching or algorithm models. Please contact @miamgao for topic configuration.':
    '话题需要预先配置，配置后可以通过关键字匹配或算法模型应用于评论的话题分类。如需配置话题，请联系@miamgao。',
  Total: '总计',
  'Total Accounts': '总计官号量',
  'Total Articles': '新闻篇数',
  'Total Engagements on Active Ads': '在投广告累计互动量',
  'Total Impressions on Active Ads': '在投广告累计曝光量',
  'Total Intent': '意图总计',
  'Total Likes': '总点赞量',
  'Total Mentions': '总声量',
  'Total Mentions Change%': '总声量变化率',
  'Total Potential Impressions': '总潜在曝光',
  'Total Publications': '总发帖量',
  'Total Rating': '总评分数',
  'Total Report': '总计举报条数',
  'Total Reviews': '评论总数',
  'Total Sessions': '直播总场数',
  'Total Social Media': '全部社媒',
  'Total Summary': '全部总结',
  'Total Views': '总观看量',
  'Total items': '总计',
  'Total-2': '全部',
  'Total-3': '总数',
  Translate: '翻译',
  'Translate: ': '翻译：',
  'Translate: Chinese': '翻译：中文',
  'Translate: English': '翻译：英文',
  'Translate: Original Language': '翻译：源语种',
  'Translation cannot be empty': '译文编辑结果不能为空',
  'Tree Diagram': '指标统计',
  Trend: '趋势',
  'Trend Comparison': '投放趋势对比',
  'Trend Detail': '热点详情',
  'Trend Topic': '热点话题',
  'Trending Content': '内容动态',
  'Trending Keywords: {A}': '突增关键词为{A}',
  'Trending Posts': '热门图文贴',
  'Trending Publications': '热门视频&帖子',
  'Trending Videos': '热门视频',
  'Trending Videos & Posts': '热门视频&图文贴',
  Trends: '趋势图',
  'Trends Analysis': '趋势分析',
  'Trends in Views': '观看量趋势',
  'Trends of Total Heat': '热度趋势',
  Tuesday: '星期二',
  'Tutorial-Core Functionality Display': '新手引导-核心功能展示',
  'Twitch Streaming': 'Twitch直播',
  'Twitch Streaming（Live Today）': 'Twitch 直播（当期直播）',
  'Twitch Viewers': 'Twitch 观看人数',
  Type: '类型',
  'Type & Element': '类型&元素',
  'Type & Elements': '类型&元素',
  'Type of Coverage': '报道类型',
  'Type the text to match the original, English, and Chinese translations of the comments.':
    '键入文本去匹配评论的原文、英译和中译。',
  'Typed text will use precise matching search in preference.': '输入的文本将优先使用精准匹配',
  'UGC Trends': 'UGC热门创意',
  URL: 'URL',
  'URL Analysis': 'URL分析',
  UV: 'UV',
  'Unable to generate a summary.': '无法生成总结',
  'Unable to generate content summary due to source website restrictions or API instability, Please {btn}':
    '无法生成内容总结，可能原因：源网站访问限制或API接口不稳定。请{btn}',
  'Unable to parse the link. Please ensure the link format is correct and reload the page.':
    '无法解析该链接。请确保链接格式正确，并重新加载页面。',
  'Unable to recognize the link': '爬虫无法识别该链接',
  'Unable to scrape subtitles from this URL': '无法从该链接获取字幕',
  'Unable to scrape the live stream comment from this URL': '无法从该链接获取弹幕',
  'Under the current selected time frame and official account, there is no data for the corresponding stream sessions. You may need to change other filtering conditions.':
    '当前所选时间及官号的条件下，无对应直播场次的数据。你可能需要更改其他筛选条件。',
  Unhealthy: '不健康',
  'Unidentified -1 ': '未识别到区域的声量',
  'Unidentified -2': '未识别到国家的声量',
  'Unidentified -3': '未识别的国家/地区',
  'Unidentified -4': '未识别国家/地区',
  'Unidentified Mentions -1': '未识别到区域的声量',
  'Unidentified Mentions -2': '未识别到国家的声量',
  'Unidentified News Mentions': '未识别地区的新闻量',
  Units: '销量',
  Unknown: '暂未获取到粉丝数',
  'Unofficial Accounts': '非官方账号',
  'Unrecognized Link': '链接无法识别',
  Unreleased: '未上线',
  Unscored: '未评分',
  Unsubscribe: '退订',
  'Unsubscribe failure': '退订失败',
  'Unsubscribe from AI Summary Emails': '取消订阅AI总结通知邮件',
  'Unsubscribe from AI Summary Notifications on WeCom': '取消订阅AI总结企业微信推送',
  'Unsubscribe successful.': '退订成功',
  'Up to': '更新于',
  'Up to 5': '5 分制',
  'Up to 50 settings can be saved': '最多保存50个方案',
  'Up to Current Hour': '截止当前小时',
  'Up to Last Hour': '截止前一小时',
  'Up to {num} games can be selected': '最多选择{num}个游戏',
  'Update Frequency': '更新频率',
  'Update Time: {time} (UTC+{timezone})': '更新时间：{time} (UTC+{timezone})',
  'Update Title': '发布标题',
  'Update {time} min ago': '{time}分钟前更新',
  'Use the original and multiple language translations text of the typed text to match the original, English and Chinese translations of the comments.':
    '使用键入文本的原文以及多个语种的翻译内容，去匹配评论的原文、英译和中译。',
  'User Reviews': '使用者评论',
  'User Score': '用户评分',
  'User Score Change%': '用户评分变化率',
  "User Score includes: Steam All Reviews Positive%、Steam Selected Reviews Positive%、OpenCritic Score、MetaCritic Score, etc. And the lifetime OpenCritic Score、MetaCritic Score cannot be split by language as they are directly scraped from the website's score.":
    '用户评分包括Steam所选时段评论正面占比、Steam累计评论正面占比、OpenCritic累计评分、MetaCritic累计评分等。其中累计评分由于直接爬取至网站得分，无法按语种拆分。',
  'User Score: Change(%)': '用户评分: 变化率',
  'User Scores by language are not supported': '暂不支持按语种显示商店用户评分',
  'User manually stopped the task.': '用户手动停止本任务。',
  Userscore: '用户评分',
  'Vaildation Editing': '编辑有效性',
  'Vaildation Editing': '编辑有效性',
  'Valid Reviews': '有效评论',
  Validation: '有效性',
  'Validation Criteria': '有效性标准',
  'Value Only': '展示指标值',
  Variety: '综合类玩家',
  Verb: '动词',
  Version: '版本',
  'Version Analysis': '版本分析',
  'Version Name': '版本名称',
  'Version Performance': '版本表现',
  'Version Selection': '版本选择',
  'Very Healthy': '非常健康',
  'Very Negative': '特别差评',
  'Very Positive': '特别好评',
  'Very Unhealthy': '非常不健康',
  Video: '视频',
  'Video (Sort by Date)': '视频 (按日期排序)',
  'Video AI Tags': '视频AI标签',
  'Video Category': '视频分类',
  'Video Comments': '视频评论量',
  'Video Content Summary': '视频内容总结 ',
  'Video Count': '视频发帖量',
  'Video Counts': '视频发帖量',
  'Video Duration': '视频时长',
  'Video Engagement': '视频互动量',
  'Video Engagement: Summary of Likes, Comments and Shares of all Videos.':
    '视频互动量：视频的点赞量、评论量、转发量的汇总。',
  'Video Engagements': '视频互动量',
  'Video Influencers': '视频类网红',
  'Video Likes': '视频点赞量',
  'Video Metrics': '视频指标',
  'Video Prompt Modification': '修改视频提示词',
  'Video Publications': '视频发帖量',
  'Video Share': '视频分享量',
  'Video Tag': '视频标签',
  'Video Tag Analysis': '视频标签分析页',
  'Video Tag Insight': '视频标签洞察',
  'Video Titles': '视频标题',
  'Video Titles-1': '视频主贴（视频标题）',
  'Video Trends': '视频热点',
  'Video Views': '视频观看量',
  'Video(Sort by Date)': '视频(按发布时间排序)',
  'Video/Post': '视频/图文贴',
  Videos: '视频',
  'Videos & Posts': '视频&图文贴',
  'Videos (Sort by Date)': '视频（按日期排序）',
  'Videos (Top 5)': 'Top5视频量',
  'Videos Sort by {value}': '视频按{value}排序',
  'Videos-2': '视频量',
  View: '观看量',
  'View AI Summary': '查看 AI 总结',
  'View All': '查看全部',
  'View Comment Details': '查看评论详情',
  'View Details': '查看详情',
  'View Feeds details for each social media platform, game store, and news channel.':
    '查看分社交媒体平台、游戏商店、新闻渠道的Feeds详情。',
  'View KOL Quotes': '查看KOL观点',
  'View Link': '查看链接',
  'View More': '查看更多',
  'View Per Post': '条均播放',
  'View Per Publication': '条均播放',
  'View Per Video': '条均播放',
  'View Prompt': '查看提示词',
  'View Related Original Comments': '查看相关原始评论',
  'View details': '查看详情',
  'View list': '查看列表',
  'View only first-time Top 100 hashtags': '仅查看首次进入Top100的Hashtag',
  'View only first-time Top 200 hashtags': '仅查看首次进入Top200的Hashtag',
  "View the game's KPIs performing": '查看游戏KPI数据表现',
  'View the mentions ratio by topic and the keywords in the word cloud.': '分话题查看声量占比，右侧查看关键字词云。',
  'View the mentions ratio by topic, and the keywords through the word cloud.':
    '分话题查看声量占比，右侧查看关键字词云。',
  'View the mentions ratio by topic. Click on a single topic and view the keywords of the topic through the word cloud on the right.':
    '分话题查看声量占比，点击单一话题，右侧查看该话题下关键字词云。',
  Viewers: '观众量',
  Views: '观看量',
  'Views (Top 5)': 'Top5观看量',
  'Views-1': '播放量',
  'Views-2': '总播放',
  'Visit original site': '查看源网址',
  'Voice Reporting Text Analysis': '语音举报文本分析',
  Votes: '投票量',
  WAU: '周活',
  "We couldn't generate the AI summary for this content. Please contact {contact} for help.":
    '所选内容无法生成AI总结，如有疑问请联系 {contact} 。',
  'We couldn’t generate the AI summary for this content. Please contact sophiaxwxu@tencent.com for help.':
    '无法生成该内容的AI总结，如需帮助请联系sophiaxwxu@tencent.com',
  'We recommend language filter. Region filter only fits some official accounts and creators.':
    '推荐使用语种筛选器，区域筛选器仅适用于筛选官号和发帖人。',
  Wednesday: '星期三',
  Week: '周',
  Weekly: '按周',
  'Weekly Avg. DAU': '周日均DAU',
  'Weekly Avg. Download': '周均下载',
  'Weekly Tracking of Channel Ranking': '渠道排名周度追踪',
  'Weekly Tracking of Key Metrics': '核心指标周度追踪',
  "What it's about. <Exclude> Unwanted Content": '话题包含内容。<排除>内容',
  'When defining a topic, follow the logic of "[{topic_name}] + [{text}] + [{text1}]" to help the system identify more accurately.':
    '定义话题时，请遵循"[{topic_name}] + [{text}] + [{text1}]"的逻辑，以帮助系统更准确地识别。',
  'When too many events are selected, some may not be fully displayed on the chart due to space constraints. To view all the events, hover your mouse over the numbers below the axis.':
    '所选事件过多时，可能导致图表上事件显示不全；查看所有事件，请将鼠标悬浮在坐标轴下方的数字上。',
  'White Paper': '白皮书',
  'Whole Sentence Sentiment': '全句情感分',
  'Why Hot': '热门原因分析',
  "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries.":
    '所选日期范围内，取最新有数据的一天，这天中不同国家的历史累计商店评分值求平均。（不考虑在这天历史累计商店评分没有值的国家；国家和日期以外其他筛选器不生效）',
  "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries. (Excluding countries that lack Lifetime User Score on this day; Filters other than country and date do not take effect)\nThe countries displayed in Google Play reviews are obtained by crawling through the Google Play scores for each language and then mapping the language to the country.\nClick to see the National Language Mapping rule >":
    '所选日期范围内，取最新有数据的一天，这天中不同国家的历史累计商店评分值求平均。（不考虑在这天历史累计商店评分没有值的国家；国家和日期以外其他筛选器不生效）\n展示在页面 Google Play的国家应用市场评分，是 DataBrain 通过 Google Play 的语种爬取评分后，再通过语种映射到国家而获得。\n点击查看国家语种映射对照表 >',
  WoW: '周环比',
  'Word Cloud chart': '词云图',
  Words: '关联词',
  'X Trends': 'X 趋势',
  'X-axis = Mentions': 'X = 周声量',
  'Y-axis = Average Engagement (Mentions / Engagements)': 'Y = 平均互动强度（声量 / 互动量）',
  Year: '年份',
  'Year to Date': '今年至今',
  Yes: '是',
  Yesterday: '昨天',
  'You are unable to view the game data currently, please feel free to contact {contact} for permissions.':
    '您目前无法查看游戏数据，请随时联系 {contact} 以获取权限。',
  'You can choose up to 9 games': '最多能选择9个游戏',
  'You can go to [{name}] to create a new report, and it will automatically update based on your selected schedule.':
    '前往 【{name}】创建新例行报告，你设定报告例行周期后系统将自动更新内容。',
  'You can go to the [{Configuration}] to add a new weekly report.': '可以点击跳转到{Configuration}增加周报',
  "You can provide some suggestions or other reports you'd like to subscribe to.":
    '您可以反馈一些建议或者其他希望订阅的报告。',
  'You can switch the game in the side menu, or enter the main page of competitors from the competitor module.':
    '主页切换游戏，或从竞品模块直接进入竞品舆情主页。',
  'You can view the analysis in the “{text}”.': '你可以在“{text}”中查看分析报告。',
  'You can view the details of all opinions data sources and the detailed definitions of all opinions metrics in the Opinions system.':
    '查看舆情监控数据源和渠道明细，以及舆情所有指标详细定义。',
  'You can visit the [{name}] to experience AI Summary feature.': '前往 【{name}】，探索 AI 总结功能',
  'You can visit the [{name}] to experience AI Summary, Keyword Analysis, and URL Analysis features.':
    '前往 【{name}】，探索 AI 总结、关键词分析以及 URL 分析功能',
  'You haven’t saved this content. It will be lost if you confirm.': '当前已输入的内容尚未保存，如离开将丢失所有内容。',
  'You will no longer receive any WeCom notifications related to the AI Summary. If you wish to re-enable this WeCom notification service, please contact: {email}.':
    '您将不再收到与AI总结相关的任何企业微信推送。如需重新启用此推送服务，请联系：{email}。',
  'You will no longer receive any email notifications related to the AI Summary. If you wish to re-enable this email notification service, please contact: {email}.':
    '您将不再收到与AI总结相关的任何邮件通知。如需重新启用此邮件通知服务，请联系：{email}。',
  'YouTube shorts': 'Youtube短视频',
  '[Custom AI Summary]': '【自定义AI总结】',
  '[Saved Analysis List]': '【已保存报告列表】',
  '[Summary List]': '【总结列表】',
  and: '且',
  'and statistically analyzed by language detection': ',通过语种识别统计',
  'by Account': '官号',
  'by DataBrain Crawling': '评论来自DataBrain爬虫',
  'by External Data Sources': '外部数据源',
  'by Game Store': '商店',
  'by Keyword': '关键字',
  'by Steam Homepage': '直接来自Steam页面的数据统计',
  'by {name}': '按{name}',
  'click to view the latest data': '点击查看最新数据',
  'click to view the latest data.': '点击可查看最新数据',
  common: '普通发帖用户',
  'data.ai DAU': 'data.ai 日活',
  'data.ai Download': 'data.ai 下载',
  'data.ai MAU': 'data.ai 月活',
  'data.ai Revenue': 'data.ai 收入',
  'data.ai WAU': 'data.ai 周活',
  day: '天',
  days: '天',
  'download Original Comments': '下载原始评论表格',
  'events-1': '条事件',
  feedback: '反馈',
  fold: '收起',
  "from the game's release on Steam to {time}": '从游戏在steam上发布到{time}',
  hour: '小时',
  hours: '小时',
  'it requires 0.5~1 hours to complete.': '需要0.5~1小时完成爬取',
  'items in total': '总计X条数据',
  keyWords: '关键字',
  'last 30 days up to {time}': '近30天截至{time}',
  'live stream comment': '弹幕',
  macro: '中网红',
  mega: '大型网红',
  micro: '微网红',
  'mid-tier': '小网红',
  'module-1': '模块',
  month: '月',
  months: '月',
  nano: '纳米网红',
  negative: '负面',
  neutral: '中性',
  or: '或',
  'out of {total} Engagement': '所选时段总互动量 {total} ',
  'out of {total} Reviews': '所选时段总评论 {total} ',
  'out of {total} Steam Reviews': '所选时段Steam总评论 {total} ',
  page: '页',
  pages: '页',
  positive: '正面',
  refresh: '刷新',
  'reviews are selected, including': '条评论，包含关键字',
  'show all': '展开',
  'sorry, no result found.': '暂无相关数据',
  subtitle: '字幕',
  'the Compare page': '竞品对比页',
  to: '至',
  'version-1': '版本',
  week: '周',
  weeks: '周',
  'with statistics generated based on filters': '并基于页面筛选条件自动生成统计结果',
  '{count} comment have been crawled.': '已爬取 {count} 条评论',
  '{count} comments have been crawled.': '已爬取 {count} 条评论',
  '{count} review is selected, including': '总计{count}条评论，包含关键字',
  '{count} reviews are selected, including': '总计{count}条评论，包含关键字',
  '{language} All Reviews': '{language} 全部评论',
  '{language} All Reviews/Total': '{language} 全部评论/总计',
  '{record_duration} hrs on record': '游戏时长{record_duration}小时',
  '{record_duration} hrs on record ({review_duration} hrs at review time)':
    '游戏时长{record_duration}小时(玩了{record_duration}小时后评论)',
  '{review_duration} hrs at review time': '玩了{review_duration}小时后评论',
  '{total} Reviews are included': '包含 {total} 条评论',
  '“Recent Reviews” refer to reviews from the past 30 days. Therefore, data is only available starting from the 31st day after launch.':
    '“近期评论”特指过去Steam30天内收到的评论。因此，游戏上线的第31天起可提供该数据。',
  '↑ Increase ↓ Decrease': '↑ 上升 ↓ 下降',
  '≤ Less than or equal': '≤ 小于等于',
  '≥ Greater than or equal to': '≥ 大于等于',
  '《Opinions Game》': '《舆情游戏》',
  参数校验错误: '参数校验错误',
  系统错误: '系统错误',
};
